<template>
  <svg
    :x="svgCoords.x"
    :y="svgCoords.y"
    width="500"
    height="475"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 372 327.9"
    id="milestone-github"
    role="presentation"
    aria-labelledby="githubandgitlab"
  >
    <title id="githubandgitlab">Launch of GitHub and GitLab Enterprise</title>
    <g class="thought-bubbles">
      <g>
        <path
          class="a"
          d="M264.4,123.8l11.8-6.7c.9-.5,1.6,0,1.6,1.2v3.9a3.6,3.6,0,0,1-1.6,3l-2.8,1.6a8.1,8.1,0,0,1-3.5,5.1c-.1,0-.1,0-.1-.2a6,6,0,0,0,.3-2.8l-5.7,3.1c-.9.5-1.7,0-1.7-1.2V127A4.4,4.4,0,0,1,264.4,123.8Z"
          transform="translate(-0.6 -0.4)"
        />
      </g>
      <g>
        <path
          class="a"
          d="M274.6,134.7l19.5-11.2c.9-.4,1.7,0,1.7,1.2v9a3.7,3.7,0,0,1-1.7,3l-2.2,1.3a7.5,7.5,0,0,1-3.4,5.1h-.2a5.4,5.4,0,0,0,.3-3l-13.9,8.1c-.9.4-1.6,0-1.6-1.2v-9A4.1,4.1,0,0,1,274.6,134.7Z"
          transform="translate(-0.6 -0.4)"
        />
        <path class="b" d="M290.7,130.1l-13.3,7.7.5.9,13.4-7.7Z" transform="translate(-0.6 -0.4)" />
        <path class="b" d="M290.8,133.2l-13.3,7.7.5.9,13.3-7.7Z" transform="translate(-0.6 -0.4)" />
      </g>
      <g>
        <path
          class="a"
          d="M261.5,162.6l19.6-11.2c.9-.5,1.7,0,1.7,1.2v16.6a3.7,3.7,0,0,1-1.7,3l-12.1,7a3.3,3.3,0,0,0,.3,2.7.9.9,0,0,1-.1.5c-2.6,1.5-3.3-.5-3.5-1.1l-4,2.4c-.9.5-1.6,0-1.6-1.2V165.9A3.4,3.4,0,0,1,261.5,162.6Z"
          transform="translate(-0.6 -0.4)"
        />
        <path class="b" d="M277.7,158.5l-13.3,7.7.5.9,13.4-7.7Z" transform="translate(-0.6 -0.4)" />
        <path class="b" d="M277.7,161.5l-13.3,7.7.5.9,13.3-7.7Z" transform="translate(-0.6 -0.4)" />
        <path class="b" d="M277.8,164.6l-13.4,7.7.5.9,13.4-7.7Z" transform="translate(-0.6 -0.4)" />
        <path class="b" d="M277.7,167.6l-13.3,7.7.5.9,13.3-7.7Z" transform="translate(-0.6 -0.4)" />
      </g>
    </g>
    <g>
      <path
        class="a"
        d="M289.9,187.8l-17.7,10a3.3,3.3,0,0,1-2.9-.2l-4.9-2.8c-.9-.4-.9-1.2-.2-1.6L282,183.1a3.3,3.3,0,0,1,2.9.2l4.9,2.8C290.7,186.6,290.7,187.3,289.9,187.8Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M271.1,198.5a3.7,3.7,0,0,1-1.8-.4l-4.9-2.9a1.5,1.5,0,0,1-.9-1.3,1.7,1.7,0,0,1,.7-1.2L282,182.5a3.8,3.8,0,0,1,3.3.2l4.9,2.8a1.6,1.6,0,0,1,.9,1.4,1.7,1.7,0,0,1-.7,1.2l-17.8,10A2,2,0,0,1,271.1,198.5Zm12.1-15.2h-1l-17.8,10.2-.3.3c0,.2.1.3.4.5l5,2.8a2.9,2.9,0,0,0,2.4.1l17.7-10a.3.3,0,0,0,.3-.3c0-.1-.1-.3-.4-.4l-4.9-2.9A2.1,2.1,0,0,0,283.2,183.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="c" d="M288.6,245.9h-1.3l-19.5,11.2v.8Z" transform="translate(-0.6 -0.4)" />
      <path
        class="c"
        d="M291.7,246.2l-1.2-.2L268,259a2.6,2.6,0,0,0,.3.8Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M294.6,246.8a4.5,4.5,0,0,0-1.1-.3l-24.6,14.2.4.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M297,247.5a3.2,3.2,0,0,1-.9-.3l-26.2,15.1.6.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M299.2,248.4a3.2,3.2,0,0,0-.9-.3l-26.9,15.6.6.4Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M300.6,249.2h0l-27.2,15.7a1.1,1.1,0,0,0,.7.3l27.2-15.7Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M302.8,250.8l-.6-.4-26.9,15.5a1.6,1.6,0,0,0,.9.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M304.1,252.2c-.1-.2-.3-.3-.4-.6l-26.2,15.1a3.2,3.2,0,0,1,.9.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="c" d="M305.3,253.7l-.4-.6-24.8,14.2h1Z" transform="translate(-0.6 -0.4)" />
      <path
        class="c"
        d="M305.9,255.5c0-.3-.1-.5-.1-.8l-22.7,13,1.2.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="c" d="M306.1,256.8,286.5,268H288l18.1-10.4Z" transform="translate(-0.6 -0.4)" />
      <path
        class="c"
        d="M305.3,260.2a11.7,11.7,0,0,0,.5-1.1l-15.3,8.8,2-.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M303.4,262.8l-6.6,3.7a21.7,21.7,0,0,0,3.8-1.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="c" d="M279.6,246.6l-3.1.9-5.8,3.5-1.7,1.8Z" transform="translate(-0.6 -0.4)" />
      <path
        class="c"
        d="M282.9,246l-14.8,8.6a5.4,5.4,0,0,1-.3,1l16.9-9.7Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M353.6,281.4l-.6-.3,16-9.3-.7-.3-20.2,11.7.6.3-16,9.3.7.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M335.4,294.2l20.3-11.6-.6-.3L371,273l-.6-.5L350,284.4l.6.3-15.8,9.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M357.6,283.8l-.5-.3,15.5-9a.6.6,0,0,0-.5-.6L352,285.6l.7.3-16.1,9.2.7.5Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="c" d="M359.7,285l-.7-.5-20.2,11.8.6.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M361.7,286.2l-.8-.5-20.1,11.7.7.4Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M363.8,287.4l-.8-.5-20.3,11.7.8.4Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M365.7,288.6l-.7-.5-20.2,11.7.7.4Z" transform="translate(-0.6 -0.4)" />
      <path
        class="c"
        d="M367.4,289.9c0-.3-.2-.4-.5-.6L346.7,301a3.2,3.2,0,0,0,.9.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M349.6,279l-.6-.3,16-9.3-.8-.5L344,280.6l.6.3-15.5,9c.2.3.2.5.5.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M331.3,292l20.4-11.8-.8-.3,16-9.3-.7-.3L346,282l.6.3-16,9.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M353,270.9a1.5,1.5,0,0,0,.2-.9l-23.5,13.6a1.8,1.8,0,0,0,1,.2l9.2-5.3.7.5,20.2-11.7-.8-.5Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="c" d="M362.3,267.9,342,279.6l.7.4,20.2-11.7Z" transform="translate(-0.6 -0.4)" />
      <path
        class="c"
        d="M352.4,268.8l-.7-.3-24.1,13.9.8.5,9.7-5.7.6.4,20.1-11.7-.6-.4Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M333.9,258.3a3.2,3.2,0,0,0-1.7.2l-7.9,4.6-6.1,3.7H318l-20.1,11.7.7.5Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="c" d="M299.8,279.6l.8.4,35.7-20.6-.8-.5Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M338.2,260.5l-.6-.4-35.7,20.7.7.4Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M340.3,261.7l-.7-.4L303.8,282l.8.4Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M342.3,262.8l-.8-.3-35.6,20.7.6.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M344.3,264l-.7-.3-35.7,20.7.7.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M346.3,265.2l-.6-.3L310,285.6l.6.3Z" transform="translate(-0.6 -0.4)" />
      <path
        class="c"
        d="M334.3,274.6c.2.2.2.5.5.6L355,263.5l-.9-.3-5.7,3.3-.8-.4-35.7,20.7c.3.1.5.3.8.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M340.8,273.3,336,276l.7.4,20.2-11.7-.7-.4-5.9,3.3-.7-.5-25,14.4a3.3,3.3,0,0,1,1.4,0Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M314.6,264.7a3.2,3.2,0,0,0-.9-.3l-19.6,11.4a.9.9,0,0,0,.3.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="c" d="M316.7,265.9l-.7-.4-20.2,11.7.7.4Z" transform="translate(-0.6 -0.4)" />
      <path
        class="d"
        d="M296.8,255.3l-4.3,1.1-4.6-1.8.6-1.1,1.4-.4s2-.3,2.3-1.4,3.1,0,3.1,0l2,1.7Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M292.5,257l-5.5-2.1,1-2,1.8-.6c.6-.1,1.6-.4,1.8-.9a1.1,1.1,0,0,1,.6-.7c.9-.5,2.8.1,3.3.3h.1l2.3,2-.6,2.8Zm-3.7-2.7,3.8,1.5,3.8-.9.3-1.2-1.5-1.4a5.4,5.4,0,0,0-2.3-.3c-.3,1.2-2.2,1.7-2.7,1.7l-1.2.4Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M311.8,230.7s-8.7-2.8-11.1-4.9c0,0,1.5,3.1-.3,8.4s-2.1,13.6-2.5,17.1a1.9,1.9,0,0,1-1.7,1.6l-.7.2c-.9,0-2.9-.8-2.9-1.8-.1-7.1-.7-30.9.9-33.1s8.3-5.1,11.4-4.5l12.4,2.1Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M295.3,253.5a4.3,4.3,0,0,1-2.7-1,2.3,2.3,0,0,1-.7-1.4c-.3-11.5-.6-31.3,1-33.4s8.7-5.4,12-4.8l12.4,2.1.7.2-5.8,16.4h-.6c-.3-.2-6.4-2.1-9.7-4.1a14.7,14.7,0,0,1-.7,7.1c-1.1,3-1.8,9.4-2.3,13.6-.1,1.4-.3,2.6-.4,3.5a2.4,2.4,0,0,1-2.3,2.1h-.7C295.5,253.5,295.5,253.5,295.3,253.5Zm8.4-39.4c-3.1,0-8.2,2.1-9.9,4.4s-1.2,14-.7,32.6c0,.2.1.3.3.5a3.7,3.7,0,0,0,1.9.7h.8a1,1,0,0,0,1-1.1c.2-.7.3-1.9.5-3.3.4-4.5,1-10.8,2.2-13.9,1.8-4.8.5-7.8.3-7.8l-1.3-2.8,2.4,2.1c1.9,1.6,8.2,3.8,10.3,4.6l4.9-13.8-11.7-1.9A2,2,0,0,0,303.7,214.1Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M287,253.5a2.4,2.4,0,0,1,2.8-.6l-.2.2c-.6.4,0,1.2.9,1.6s4.2.8,5.4-.9l.2-.3v-.3a15.9,15.9,0,0,1,1.3-1.3.7.7,0,0,1,1.2.3,6.2,6.2,0,0,1-.1,4.3l-.3,3.4a1.1,1.1,0,0,1-.3.6.2.2,0,0,0-.2.2c-.1.1-.7,0-.9,0a7,7,0,0,1-1.2-.3c-.1,0-.3-.3-.3-.5l.2-1.6c0-.3-.2-.4-.5-.3l-.4.3a2.7,2.7,0,0,1-1.5.5,3.2,3.2,0,0,1-1.7-.3C288.9,257,285.9,255.2,287,253.5Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M297.3,261a1.1,1.1,0,0,1-.8-.2,3,3,0,0,1-1.2-.3,1,1,0,0,1-.6-.9v-1.1h-.1a3.5,3.5,0,0,1-1.7.6,6.3,6.3,0,0,1-1.9-.3c-3-1.5-4.3-2.7-4.8-3.9a1.9,1.9,0,0,1,.2-1.5c.4-.7,1.3-1.3,3.4-.7l1,.3-.9.6a.1.1,0,0,0-.1.1c0,.2.1.5.9.9s3.7.6,4.6-.7l.2-.2v-.6l1.4-1.3c.3-.3.7-.5,1-.3s.8.3.9.7a7.4,7.4,0,0,1-.1,4.7l-.3,3.2a1.4,1.4,0,0,1-.5.9c-.1.2-.1.2-.3.2A.4.4,0,0,0,297.3,261Zm-2.3-3.7h.5a.7.7,0,0,1,.3.8l-.2,1.6,1.1.3h.6v-.3l.5-3.4a5.7,5.7,0,0,0,.1-4.1.1.1,0,0,0-.1-.1h-.2l-1.2,1.2v.7a4.5,4.5,0,0,1-6,1.1c-.5-.3-1.4-.8-1.5-1.5v-.3c-.6,0-1.3,0-1.6.4a1.2,1.2,0,0,0-.2.8c.3.9,1.7,1.9,4.2,3.3l1.3.3a1.7,1.7,0,0,0,1.2-.5l.5-.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="d" d="M294.8,255.2l-.2,1.9h1l.3-1.9Z" transform="translate(-0.6 -0.4)" />
      <path
        class="a"
        d="M344.6,257.9V227.6s0-.2-.1-.2l-14.4,1.4-1.3-7.9h-.1l-29.6,16.9h-.2l-2.5-.8c-.2,0-.2,0-.2.2v30.2a1.2,1.2,0,0,0,.8,1.1l13.3,7.8a3.8,3.8,0,0,0,3.6,0l29.9-17.1A1.4,1.4,0,0,0,344.6,257.9Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M312.4,277.3a3.1,3.1,0,0,1-2.1-.6L297,268.9a2.4,2.4,0,0,1-1.1-1.5V237.2a.9.9,0,0,1,.3-.6.8.8,0,0,1,.6-.2l2.3.6,29.4-16.7a.6.6,0,0,1,.8,0h.3l1.1,7.6,13.9-1.1h.2a.9.9,0,0,1,.6.7V258a1.9,1.9,0,0,1-1.1,1.6l-29.8,17.1A3.2,3.2,0,0,1,312.4,277.3Zm-15.3-39.4v29.5a.7.7,0,0,0,.5.6l13.3,7.8a2.7,2.7,0,0,0,3,0l29.9-17a1.5,1.5,0,0,0,.4-.6h0V228.3l-13.9,1.2H330l-.3-.2-1.2-7.3-29.1,16.6h-.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M344.6,227.4l-14.3,1.4L312.2,243v33.7a4.8,4.8,0,0,0,2-.4L344,259.2a1.4,1.4,0,0,0,.8-1.2c-.2-.1-.2-30-.2-30.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M312.4,277.3h-.8V242.7L330.3,228v.2l14.2-1.3h.2a.9.9,0,0,1,.6.7V258a1.7,1.7,0,0,1-1.1,1.6l-29.8,17.1A3.2,3.2,0,0,1,312.4,277.3Zm.4-34V276l1.1-.3,29.9-17.1a.8.8,0,0,0,.4-.6V228.2l-13.6,1.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M298.6,238.8a10.4,10.4,0,0,1,.5-1.2l-2.4-.6c-.2,0-.2,0-.2.2v30.2a1.2,1.2,0,0,0,.8,1.1l1.3.7V238.8Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M299.2,270.3l-2.2-1.4a2.4,2.4,0,0,1-1.1-1.5V237.2a.9.9,0,0,1,.3-.6.8.8,0,0,1,.6-.2l3,.9-.3.6a8.3,8.3,0,0,1-.4,1.2Zm-2.1-32.5v29.5a1.2,1.2,0,0,0,.5.6l.4.3V238.8h0a1.3,1.3,0,0,0,.2-.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M310.6,245.9l-13.3-7.8a1.4,1.4,0,0,1,0-2.4l29.9-17.1a3.6,3.6,0,0,1,3.5,0l13.3,7.8a1.4,1.4,0,0,1,0,2.4l-29.8,17.1A3.3,3.3,0,0,1,310.6,245.9Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M312.4,247.1a3.7,3.7,0,0,1-2.1-.6L297,238.7a2,2,0,0,1,0-3.6L326.9,218a4.3,4.3,0,0,1,4.1,0l13.3,7.8a2.2,2.2,0,0,1,1.1,1.8,2.5,2.5,0,0,1-1.1,1.8l-29.8,17.1A6.1,6.1,0,0,1,312.4,247.1ZM329,218.8a2.6,2.6,0,0,0-1.5.4l-29.9,17.1a1,1,0,0,0-.5.7.8.8,0,0,0,.5.8l13.3,7.8a3.4,3.4,0,0,0,2.8,0l29.9-17.1a1,1,0,0,0,.4-.8.8.8,0,0,0-.4-.7l-13.3-7.8A2.2,2.2,0,0,0,329,218.8Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M291,190l-2.5-1.6a5.1,5.1,0,0,0-3.2-.8c-1.5.2-2.4.5-3.1,1.8l-.2.6,2.6.9v.5l-.7.4s.7,2.7,5.2,2S291,190,291,190Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M287.7,194.3c-3.7,0-4.5-2.3-4.5-2.5v-.4l.3-.2-2-.7.2-1.4c.9-1.6,2.1-1.9,3.6-2.1a6.7,6.7,0,0,1,3.6.9l2.6,1.8a2.9,2.9,0,0,1,.6,2.9c-.3.9-1.3,1.5-2.8,1.6Zm-3-2.5c.5.6,1.7,1.5,4.3,1.1.8-.2,1.7-.3,2-.9a3.3,3.3,0,0,0-.3-1.5l-2.4-1.7a4.6,4.6,0,0,0-2.7-.7,2.7,2.7,0,0,0-2.5,1.3l2.4.8.3,1.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M293.4,190.9l-1.5-.9h-.8a9.5,9.5,0,0,0-1.8,2.7c-.1.3,0,.8.3.9l1.7.7a.5.5,0,0,0,.7-.2l1.4-2.3C293.8,191.7,293.7,191.1,293.4,190.9Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M291.7,195.1l-.6-.2-1.6-.7a1.4,1.4,0,0,1-.7-1.6,7,7,0,0,1,1.9-3,1.3,1.3,0,0,1,1.5-.2l1.5.9a1.1,1.1,0,0,1,.6.9,1.5,1.5,0,0,1-.2,1.1l-1.3,2.2A1.5,1.5,0,0,1,291.7,195.1Zm-.1-4.5a5.5,5.5,0,0,0-1.7,2.4v.2l1.7.7,1.3-2.2v-.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="d"
        d="M310.4,189.3c-.4,1,.5-1.5,0,0-1.5,3.9-3.3,8.2-3.3,8.2s-4.2-2.1-7.3-3.2a23.6,23.6,0,0,1-5.5-2.9h-.2a3.6,3.6,0,0,0-2.4,3.1l.2.3c1,1,10.7,9.7,17.9,11.4a25.3,25.3,0,0,0,6.3-11C317.9,187.9,311.2,186.6,310.4,189.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M309.8,206.6h-.3c-7.3-1.6-17.2-10.5-18.2-11.5a1.1,1.1,0,0,1-.3-.8,4.2,4.2,0,0,1,2.8-3.7.8.8,0,0,1,.8.2,28,28,0,0,0,5.4,3c2.4.8,5.5,2.2,6.8,2.8l3-7.5h.2c.1-.3.1-.5.3-.6a3.1,3.1,0,0,1,3.4-.8c2.4.8,4.2,3.5,2.8,7.8a24.1,24.1,0,0,1-6.4,11.2Zm-17.6-12.4c1.5,1.3,10.4,9.3,17.2,11.1a26.4,26.4,0,0,0,5.8-10.4c1.1-3.7-.4-5.6-2.1-6.1a1.8,1.8,0,0,0-2.1.5,1.1,1.1,0,0,1-.3.6l-3.1,7.7-.3.6-.6-.3a65.3,65.3,0,0,0-7.3-3.1,22.1,22.1,0,0,1-5.6-3A3.3,3.3,0,0,0,292.2,194.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="d"
        d="M278.3,251.4a4.3,4.3,0,0,1-2.9,1.4,3.5,3.5,0,0,0-2.6,1.5l2.2,2.8h4.6l2.6-1.8.7-3-2.8-1.4Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M274.7,257.6l-2.8-3.5.3-.4a4.2,4.2,0,0,1,3.1-1.8,3.9,3.9,0,0,0,2.4-1.1h.1l2.1-.9,3.6,1.6-.9,3.8-2.8,2.1Zm-1.2-3.5,1.8,2.3,4-.2,2.1-1.5.5-2.2-2.1-.9-1.2.4a5.3,5.3,0,0,1-3.3,1.4A2.5,2.5,0,0,0,273.5,254.1Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M326.7,228.8s-11,18.9-38.7-2.2c-.1-.2-.3,0-.3.1a12.9,12.9,0,0,1-.6,8.7c-1.8,3.9-3.4,12.6-4.2,15.9a1.7,1.7,0,0,1-1.6,1.5h-.8a2.3,2.3,0,0,1-2.2-2c.3-7,1.3-30.8,3-32.8s8.8-2.8,11.9-2.1l20.8,5.9Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M280.5,253.4a3.6,3.6,0,0,1-2.2-1.1,1.5,1.5,0,0,1-.6-1.6v-.3c.9-21.3,1.8-31.3,3.1-32.8,2.9-3.3,9.3-3.2,12.6-2.3s20.6,5.7,20.8,5.9h.1l13.2,7.3-.3.6a18.2,18.2,0,0,1-11.7,7.6c-7.8,1.5-16.9-1.5-27-9a14.3,14.3,0,0,1-.9,7.8c-1.7,3.6-3.2,11.3-3.9,15l-.2.8a2.3,2.3,0,0,1-2.2,1.9Zm8.3-37.3c-2.7,0-5.6.6-7.1,2.4s-1.8,7-2.8,32v.3a1.3,1.3,0,0,0,.3.8,2.2,2.2,0,0,0,1.3.6h.8a1.1,1.1,0,0,0,1-.9l.2-.8c.7-3.7,2.4-11.5,4-15.3a11.9,11.9,0,0,0,.5-8.2.7.7,0,0,1,.3-.9h.9c10.3,7.8,19.2,10.9,27,9.4a17.1,17.1,0,0,0,10.5-6.6l-12-6.7-20.8-5.7A15.8,15.8,0,0,0,288.8,216.1Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M271.3,254.4c.4-1.6,1.9-1.9,4-1.6a2,2,0,0,0-1.3.9c-.6.6,0,1.2,1.1,1.6a4.6,4.6,0,0,0,5.6-1.5l.3-.3.3-.4v-.2l1.2-1.5a.9.9,0,0,1,1.4.2,6.4,6.4,0,0,1,.1,4.5v3.5a.6.6,0,0,1-.3.6.4.4,0,0,1-.4.2,3.9,3.9,0,0,1-1.7-.2l-.4-.4-.2-1.8c0-.1-.1-.3-.3-.1l-.3.3-1,.7a3.9,3.9,0,0,1-2.6,0C274.3,258.2,270.8,256.7,271.3,254.4Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M282.9,261.1h-1.3c-.5-.2-.8-.5-.8-.9v-1.3a6,6,0,0,1-1.1.6,4.4,4.4,0,0,1-3,.1c-1.9-.7-6.7-2.4-5.9-5.2s3.6-2.3,4.4-2.1l2.4.3-2.4.7a3.9,3.9,0,0,0-1,.8H274c0,.2.3.5,1,.8s4,.3,4.9-1.2v-.2c.2-.1.2-.1.3-.3l.3-.4h.5l-.5-.3c.3-.3.6-.9,1.2-1.5a1.7,1.7,0,0,1,1.2-.4,1.2,1.2,0,0,1,1.1.7,7.3,7.3,0,0,1,.1,4.8v3.6a1.1,1.1,0,0,1-.4.9l-.6.3C283.4,261.1,283.2,261.1,282.9,261.1Zm-1.9-3.5h.3a.5.5,0,0,1,.4.6l.2,1.7,1.3.2h.3l.2-.3v-3.7a7.2,7.2,0,0,0-.2-4.2.3.3,0,0,0-.3-.3h-.3c-.4.6-.9,1.1-1.2,1.5l-.4.6-.3.3c-1.2,2-3.6,2.6-6,1.7-.6-.2-1.5-.8-1.6-1.5a1.5,1.5,0,0,1,.3-1.1h.1c-1.5.1-1.8.7-1.9,1.3s2.8,3.3,5.3,4.2a3.1,3.1,0,0,0,2.3,0,2.4,2.4,0,0,0,.9-.6l.3-.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="d" d="M281.9,255h-1.1v2.4h1.1Z" transform="translate(-0.6 -0.4)" />
      <path
        class="c"
        d="M287.1,226.9a4.2,4.2,0,0,0-1.3-2.6l.7-1a6,6,0,0,1,1.8,3.3l-1.2.3h0Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M328.2,198.1s2.4,15.3,3.6,23.5-9.4,12.7-16.3,13.5-14-2.9-16.3-6.5a15,15,0,0,0-5.5-5.2s8.8-6.1,11.2-21.9,11.2-18.2,11.8-18.1S328.2,198.1,328.2,198.1Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M313.6,236c-6.5,0-12.7-3.5-14.8-6.9a16.9,16.9,0,0,0-5.3-5.1l-.9-.4.9-.6c.2,0,8.6-6.2,11.1-21.5,2.7-16.9,12.2-18.7,12.4-18.7s.7,0,12,14.8v.2h0s2.4,15.3,3.6,23.6a8.8,8.8,0,0,1-1.8,6.8c-3.1,4.2-9.9,6.8-15.1,7.4A6.4,6.4,0,0,1,313.6,236Zm-18.7-12.6a17.1,17.1,0,0,1,4.9,4.9c2,3.2,8.8,7.1,15.7,6.2,4.9-.6,11.4-3,14.2-6.9a8.2,8.2,0,0,0,1.6-6c-1.2-7.8-3.2-21.7-3.5-23.4-3.8-5-9.9-12.8-11.1-14.2-1.2.3-8.7,3.3-10.9,17.7S297.1,221.6,294.9,223.4Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M297,224.8l-.6-.8c7-4.6,10.3-15.4,10.4-15.6l.9.3C307.6,209.2,304.1,220,297,224.8Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M281.3,194.3a9.2,9.2,0,0,0-2.1-3.4c-.9-.7-1.5,0-1.8.5h-.5l-2.5-1.5a.8.8,0,0,0-.9.2,3.2,3.2,0,0,0-.1,3.4c1,2.7,5.5,3.6,5.5,3.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M279,197.9h-.4c-.2,0-4.8-1.1-6-4a4.7,4.7,0,0,1,.3-4.1,1.3,1.3,0,0,1,1.7-.4l2.3,1.3a2.1,2.1,0,0,1,1.2-.7,2.3,2.3,0,0,1,1.4.4,11.2,11.2,0,0,1,2.2,3.8l.2.2Zm-4.9-7.3c-.4.5-.7,1.4-.1,2.9s3.2,2.8,4.6,3.1l1.9-2.4a7.9,7.9,0,0,0-1.8-2.8.4.4,0,0,0-.3-.2,1.2,1.2,0,0,0-.6.5.8.8,0,0,1-1.2.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M283.1,195.4l-1.4-1.3a.6.6,0,0,0-.7-.2,6.8,6.8,0,0,0-2.7,2.2.8.8,0,0,0,.1,1.1l1.7,1.3a.6.6,0,0,0,.9,0l2.1-1.9A.9.9,0,0,0,283.1,195.4Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M280.4,199.4l-.9-.3-1.7-1.3a1.7,1.7,0,0,1-.3-2,7.4,7.4,0,0,1,3-2.5,1.2,1.2,0,0,1,1.5.3l1.4,1.3a1.4,1.4,0,0,1,.4,1.1,1.3,1.3,0,0,1-.4,1l-2.1,2A1.2,1.2,0,0,1,280.4,199.4Zm.9-4.9a4.8,4.8,0,0,0-2.6,1.9v.3l1.7,1.4,2.2-2h0v-.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="d"
        d="M309.5,191.4a1.8,1.8,0,0,0-2.1-.9,2.1,2.1,0,0,0-1,.6,31.7,31.7,0,0,0-4,4.9c-2.4,3.7-7.7,10.5-7.7,10.5s-3.7-3.3-6.4-5.4a29.9,29.9,0,0,1-4.8-4.7h-.1a3.2,3.2,0,0,0-3.2,2.4v.3c.8,1.2,7.7,12.1,14.2,16.3a1.2,1.2,0,0,0,1.4-.1c2.1-1.8,8.3-7.7,11.5-12.9S310.4,192.9,309.5,191.4Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M295,216.1l-.9-.3c-6.5-4.2-13.6-15.3-14.3-16.5a1.3,1.3,0,0,1-.2-.8,3.8,3.8,0,0,1,3.8-2.8.8.8,0,0,1,.7.3,19.9,19.9,0,0,0,4.7,4.5c2.2,1.6,4.9,4,5.9,4.9a118.4,118.4,0,0,0,7.2-9.9,30.8,30.8,0,0,1,4-4.9,4.6,4.6,0,0,1,1.4-.7,2.9,2.9,0,0,1,2.8,1.2c1.5,2.5.8,6.2-2.2,11.3s-9.7,11.4-11.7,13.1A1.4,1.4,0,0,1,295,216.1Zm-14.2-17.4c1.1,1.6,7.7,12,13.9,16,.2.2.5.2.6,0,2-1.6,8.2-7.5,11.4-12.7s3.4-8.1,2.2-10.2l.5-.3-.6.3a1.6,1.6,0,0,0-1.5-.6,1,1,0,0,0-.8.5,29.3,29.3,0,0,0-3.9,4.7c-2.3,3.8-7.6,10.5-7.6,10.7l-.4.6-.5-.5s-3.7-3.3-6.4-5.4a31,31,0,0,1-4.8-4.6C282.6,196.9,281.4,197.2,280.8,198.7Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M294,209.5a9,9,0,0,1,.1-3.2l1.2.3a6.4,6.4,0,0,0-.1,2.7Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M310.7,181.5s1.2,3.7.2,5.5,3.6,1.4,3.6,1.4l4.6-3.3a10,10,0,0,1-1.4-4.2c.2-2,.3-2.1-.1-2S310.7,181.5,310.7,181.5Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M313.3,189c-1.1,0-2.4-.2-2.9-.9a1.7,1.7,0,0,1,0-1.4c.8-1.3.2-4-.1-5.1l-.2-.6h.6l7-2.7c.2,0,.5-.2.8.1s.3.6.3,1.2a4.2,4.2,0,0,1-.2,1.4,9.2,9.2,0,0,0,1.2,3.9l.3.4-5.2,3.8h-1.6Zm-1.8-7.2c.3,1.2.7,3.9,0,5.5v.2c.1.3,1.6.3,2.8.3l4-3a8.3,8.3,0,0,1-1-4.1,4.5,4.5,0,0,1,.1-1.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M305.3,177.1l-.3-.3a9.4,9.4,0,0,1-2.1-9.4c2-5.3,8.3-5.1,8.3-5.1h.6v.6c0,.3.9,7.5,0,9.9s-5.6,4-6.2,4.2Zm5.3-13.5c-1.4.2-5.1.6-6.5,4.4s.8,6.9,1.5,7.8,4.4-1.8,5-3.3S310.9,165.9,310.6,163.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="d"
        d="M314.5,163.6s4-3.2,5.5,5c1,5.8-1.2,9.3-5.5,12.6a4.4,4.4,0,0,1-4.2.7,5.9,5.9,0,0,1-3.6-4.2,20.1,20.1,0,0,1-.6-10c-.8-3.5,1.5-3,5.5-4.1Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M311.6,183l-1.5-.3a6.5,6.5,0,0,1-4-4.7,21,21,0,0,1-.6-10.2,3.4,3.4,0,0,1,.1-2.5c.6-.9,1.8-1.2,3.5-1.5l2.4-.6h.1l2.7-.2a3.2,3.2,0,0,1,3-.4c1.6.6,2.7,2.5,3.4,6,1.1,5.5-.6,9.3-5.6,13.2A7.3,7.3,0,0,1,311.6,183Zm.2-18.6-2.4.6c-1.4.3-2.4.4-2.7,1a2.6,2.6,0,0,0,0,1.8v.2h0a18.6,18.6,0,0,0,.6,9.6,5.6,5.6,0,0,0,3.1,3.8,3.7,3.7,0,0,0,3.6-.8c3.9-3,6.3-6.3,5.2-12-.7-3.6-1.8-4.8-2.5-5.1a2.2,2.2,0,0,0-1.9.5h-.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M311.8,191.1c-1.8.3-4.8-2.1-3.3-3.3v-.2c1.2-.7,5,.3,7.2-1.2s1.8-2.2,1.6-2.8a1.1,1.1,0,0,1,.3-1.1,2.1,2.1,0,0,1,1.1-.3,2.4,2.4,0,0,1,1.6,3.3,8.3,8.3,0,0,1-4.7,4.5A9.2,9.2,0,0,1,311.8,191.1Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M311.5,191.8a4.5,4.5,0,0,1-3.9-2.4,1.9,1.9,0,0,1,.4-2.1h.3a5.2,5.2,0,0,1,2.9-.5,8.7,8.7,0,0,0,4.3-.7c1.5-.9,1.5-1.8,1.3-2.1a1.7,1.7,0,0,1,.6-1.7,3.9,3.9,0,0,1,1.5-.4,2.3,2.3,0,0,1,2,1.2,3.2,3.2,0,0,1,.3,3,9.8,9.8,0,0,1-5.1,4.9,19.9,19.9,0,0,1-4,1.1A.6.6,0,0,0,311.5,191.8Zm-.8-3.9a4.4,4.4,0,0,0-1.8.2h-.1c-.2.2-.3.3-.2.6a3.8,3.8,0,0,0,3,1.7,37.5,37.5,0,0,0,3.9-.9,7.6,7.6,0,0,0,4.3-4.1,2.2,2.2,0,0,0-.1-1.8c-.3-.3-.6-.6-.9-.6s-.5,0-.6.2-.2.3-.2.4.2,2.1-1.9,3.5-3.4.9-4.9.9A.6.6,0,0,0,310.7,187.9Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M313,160.4c-3.2.4-6.9,2.9-7.5,5s-.5,4.1,2.2,3.8c1.1-.2,2,2.7,2.3,3.7s1.2,1.1,1.5.9,1.9,1.1,2.1,2.3a3.4,3.4,0,0,1-.9,2.7c1.8,4.2-6.6,8.8,1.6,12.1.2.2-5.7,8.2,2,12.7s19.1,2.4,22.1-4.9c4.9-12.7-12.6-15.1-13.3-26.1C324.3,164.4,318,159.8,313,160.4Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M324.8,206.5a18.5,18.5,0,0,1-8.8-2.1c-3.2-2-6.3-5.7-2.6-13a6,6,0,0,1-3.3-2.9c-.6-1.6.2-3.3.9-4.9s1.5-3,.9-4.4v-.4l.4-.3a3.1,3.1,0,0,0,.6-2.1,2.1,2.1,0,0,0-.7-1.5l-.6-.3a2.3,2.3,0,0,1-2.1-1.4c0-.1-.2-.3-.2-.6-.7-2.2-1.2-2.8-1.5-2.8a3.1,3.1,0,0,1-2.7-.8c-.6-.7-.6-1.9-.1-3.9s4.6-5,8.1-5.5a10,10,0,0,1,7.4,2.4,15.2,15.2,0,0,1,5.3,10.8c.3,4.5,3.7,7.5,7,10.5s9.1,8.2,6.1,15.7c-1,2.8-3.6,4.9-7.2,6.3A16.8,16.8,0,0,1,324.8,206.5Zm-11.4-27.3c.5,1.8-.3,3.5-1,5s-1.4,2.8-.9,3.9,1.3,1.6,3.1,2.4h.3l.2.3c.1.3,0,.5-.3,1.1-2.9,5.2-2.1,8.9,1.9,11.3s9.9,2.6,14.6.9c2.3-.7,5.3-2.4,6.5-5.5,2.7-6.7-1.5-10.5-5.9-14.4s-7.1-6.3-7.4-11.4a14,14,0,0,0-4.8-9.9,9.5,9.5,0,0,0-6.6-2.1c-2.8.3-6.4,2.7-7,4.7a3.6,3.6,0,0,0-.2,2.7c.3.4,1.1.4,1.7.3s2.2,2.1,2.8,3.6a1.5,1.5,0,0,0,.2.4,1.1,1.1,0,0,0,.9.6,2.6,2.6,0,0,1,1.5.6,3.8,3.8,0,0,1,1.3,2.4A5.6,5.6,0,0,1,313.4,179.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M314.9,191.4l-1.2-.5a10.3,10.3,0,0,1,2-3.6l.8.9A15.8,15.8,0,0,0,314.9,191.4Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M331.6,201.7l-.6-1.1a6.1,6.1,0,0,0,3.3-4.9h1.2A7.7,7.7,0,0,1,331.6,201.7Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M364.8,268.3V252.6h-.1l-14.4,1.3-1.3-7.9h-.2l-13.1,7.6h-.2l-2.5-.7h-.2v15.6a1.1,1.1,0,0,0,.8,1l13.3,7.8a3.8,3.8,0,0,0,3.6,0l13.4-7.8C364.7,269.2,364.8,268.8,364.8,268.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M348.8,278.4a3.9,3.9,0,0,1-2.1-.6L333.4,270a2,2,0,0,1-1-1.5V252.8a.6.6,0,0,1,.3-.6c.1-.2.4-.2.6-.2l2.2.6,13-7.5h.8l.3.2,1.2,7.6,13.9-1.2h.1c.3.2.6.5.6.8v15.7a1.9,1.9,0,0,1-1,1.6l-13.5,7.8A2.8,2.8,0,0,1,348.8,278.4Zm-15.1-24.7v14.8a3.3,3.3,0,0,0,.3.6l13.3,7.8a2.7,2.7,0,0,0,3,0l13.5-7.8a.9.9,0,0,0,.4-.6h0V253.4l-13.9,1.2-.3-.2h-.3l-1.2-7.4-12.7,7.4h-.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M364.8,252.6,350.5,254l-1.7,4.9v19a4.8,4.8,0,0,0,2-.4l13.4-7.8a1.5,1.5,0,0,0,.8-1.2c-.2-.2,0-15.3-.2-15.9Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M348.8,278.4h-.7V258.5l1.9-5.6.5.3,14.2-1.3h.1a.9.9,0,0,1,.6.7v15.7a1.8,1.8,0,0,1-1,1.7l-13.5,7.8A3.5,3.5,0,0,1,348.8,278.4Zm.6-19.5v18.3l1.1-.3,13.4-7.8a1.2,1.2,0,0,0,.5-.6V253.4l-13.3,1.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M335.1,254.6a4.8,4.8,0,0,1,.4-1.2l-2.4-.6H333v15.6a1.1,1.1,0,0,0,.7,1l1.4.8V254.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M335.8,271.5l-2.2-1.4a2.4,2.4,0,0,1-1.1-1.5V252.9c0-.3.2-.4.3-.6h.6l3,.9-.3.6-.4,1.2Zm-2.1-18v14.8a1.1,1.1,0,0,0,.3.6l.5.3V254.4a2.2,2.2,0,0,0,.1-.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M347.2,261.6l-13.3-7.8a1.4,1.4,0,0,1,0-2.4l13.6-7.8a3.8,3.8,0,0,1,3.6,0l13.3,7.8a1.4,1.4,0,0,1,0,2.4l-13.6,7.8A3.3,3.3,0,0,1,347.2,261.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M348.8,262.8a3.9,3.9,0,0,1-2.1-.6l-13.3-7.8a2,2,0,0,1-1-1.8,2.4,2.4,0,0,1,1-1.8L347,243a4.5,4.5,0,0,1,4.2,0l13.3,7.8a2,2,0,0,1,0,3.6l-13.6,7.8A3.7,3.7,0,0,1,348.8,262.8Zm.3-19a3.1,3.1,0,0,0-1.5.4L334,252a1,1,0,0,0-.4.8.8.8,0,0,0,.4.7l13.3,7.8a3.7,3.7,0,0,0,2.9,0l13.6-7.8c.3-.1.4-.6.4-.7a.9.9,0,0,0-.4-.8l-13.3-7.8A2.5,2.5,0,0,0,349.1,243.8Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="a" d="M333.1,255.3h-1v9.4h1Z" transform="translate(-0.6 -0.4)" />
      <path
        class="b"
        d="M356.2,239.4l-6.5-3.7a.5.5,0,0,0-.7,0l-7.8,4.8a.6.6,0,0,0-.1.4l7.4,8.1v2.7c0,.8,3-1.5,3.6-1s.2,0,.2.1l-3.9,2.4a.4.4,0,0,0,.4.2l7.8-4.8a2.2,2.2,0,0,0,.3-.8v-6.3A1.8,1.8,0,0,0,356.2,239.4Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M349,254h-.2c-.3,0-.4-.2-.6-.5l-.3-.6.8-.4a.7.7,0,0,1-.3-.6v-2.4l-7.5-8a1,1,0,0,1,.3-1.3l7.8-4.8a1.1,1.1,0,0,1,1.3,0l6.5,3.7a3.3,3.3,0,0,1,1.3,2.6v6.1c0,.6-.5,1.1-.5,1.2v.2l-7.8,4.8A.8.8,0,0,0,349,254Zm-6.9-13.1,7.2,7.8a.9.9,0,0,1,.1.5v1.9l.8-.4c1.2-.6,1.9-.9,2.5-.6h.2l3.6-2.2a.4.4,0,0,1,.1-.3v-6.2a1.5,1.5,0,0,0-.7-1.3l-6.5-3.8Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M343.3,247.8v.5l5.4,4.6c.1.3.4.3.7.2l7.7-4.8a2.2,2.2,0,0,0,.3-.8v-5.7c0-.1-.2-.3-.3-.1l-7.7,4.8Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M349.1,253.8h-.3c-.3,0-.4-.1-.6-.4l-5.6-4.8v-1.4l6.3-1.3,7.6-4.8a.7.7,0,0,1,.9,0,.7.7,0,0,1,.4.7v5.7a3.1,3.1,0,0,1-.4,1.2v.2l-7.7,4.8Zm-5.1-5.5,5,4.2,7.3-4.7c0-.1.2-.3.2-.3v-4.9l-6.9,4.3-.2.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M348.1,253.4l-6.4-3.8a2.4,2.4,0,0,1-1.1-1.9v-6.2c0-.7.5-1,1.1-.7l6.4,3.7a2.3,2.3,0,0,1,1,2v6.1C349.1,253.4,348.7,253.7,348.1,253.4Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M348.5,254.1h-.7l-6.4-3.8a2.9,2.9,0,0,1-1.4-2.5v-6.2c0-.6.3-1.2.6-1.3a1.7,1.7,0,0,1,1.4,0l6.4,3.7a3.3,3.3,0,0,1,1.3,2.6v6.1a1.8,1.8,0,0,1-.6,1.4Zm0-1.3h0l.2-.3v-6.2a1.6,1.6,0,0,0-.8-1.3l-6.4-3.8v6.5a1.6,1.6,0,0,0,.8,1.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="a" d="M356.4,245.1l-6.8,4.1.5.9,6.8-4.1Z" transform="translate(-0.6 -0.4)" />
      <path
        class="a"
        d="M344,225.2a.5.5,0,0,0-.4.5l1.2,12.1c0,.7.7,1.5,2.1,1.8h2.4c1.3-.3,2.1-1.1,2.1-1.8l1.2-12.1a.5.5,0,0,0-.5-.5Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M348.2,240.3h-1.3c-1.7-.5-2.6-1.4-2.6-2.4l-1.1-12.1a.8.8,0,0,1,.3-.8,1.1,1.1,0,0,1,.7-.3h8.2a1,1,0,0,1,1.1,1.1l-1.2,12.1c0,1-.9,1.9-2.6,2.4Zm-3.9-14.5,1.2,11.8c0,.5.5.9,1.7,1.2a3.7,3.7,0,0,0,2.1,0c1.2-.3,1.6-.7,1.6-1.2l1.2-11.9h-7.8Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M351.4,223.3c1.8,1,1.8,2.7,0,3.7a7.4,7.4,0,0,1-6.5,0c-1.7-1-1.7-2.7,0-3.7A6.8,6.8,0,0,1,351.4,223.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M348.2,228.5a7.4,7.4,0,0,1-3.6-.9,2.6,2.6,0,0,1,0-4.8,7.5,7.5,0,0,1,7.1,0,2.6,2.6,0,0,1,0,4.8A6.8,6.8,0,0,1,348.2,228.5Zm0-5.4a5.1,5.1,0,0,0-2.8.8c-.6.4-1.1.9-1.1,1.3s.3.9,1.1,1.4a7.3,7.3,0,0,0,5.8,0c.6-.5,1.1-.9,1.1-1.4s-.3-.9-1.1-1.3A6.1,6.1,0,0,0,348.2,223.1Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="c" d="M354.6,215.3l-7.1,11.9,1.3.7,7.1-11.8Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M348.1,218.6l-1.5,8.7,1.5.3,1.4-8.7Z" transform="translate(-0.6 -0.4)" />
      <path
        class="a"
        d="M361.5,284.8v-6.9h-.1L347,279.1l-1.3-7.9h-.2l-13.1,7.6h-.2l-2.5-.7h-.1V285a1.1,1.1,0,0,0,.7,1l13.3,7.8a3.8,3.8,0,0,0,3.6,0l13.4-7.8A1.4,1.4,0,0,0,361.5,284.8Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M345.5,294.8a2.8,2.8,0,0,1-2-.6l-13.4-7.7a2.7,2.7,0,0,1-1-1.5v-6.9a.9.9,0,0,1,.3-.6.8.8,0,0,1,.6-.2l2.4.6,13-7.5h.7l.3.2,1.2,7.6,13.9-1.2h.2c.3.2.6.5.6.8v6.9a2,2,0,0,1-1.1,1.6l-13.4,7.8A3.5,3.5,0,0,1,345.5,294.8Zm-15.2-16v6a.6.6,0,0,0,.4.6l13.3,7.8a2.7,2.7,0,0,0,3,0l13.5-7.8a.6.6,0,0,0,.4-.6v-6.3L347,279.7h-.3l-.3-.2-1.2-7.3-12.7,7.3h-.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M361.4,277.8,347,279.1l-1.6,5v10.3a4.5,4.5,0,0,0,1.9-.5l13.5-7.7a1.7,1.7,0,0,0,.7-1.2c0-.2,0-6.6-.1-7.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M345.5,294.8h-.7v-11l1.9-5.7.5.3,14.2-1.4h.1c.3.2.6.5.6.8v6.9a1.8,1.8,0,0,1-1,1.6l-13.5,7.8A2.7,2.7,0,0,1,345.5,294.8Zm.5-10.7v9.5a1.9,1.9,0,0,0,1-.3l13.5-7.7a.9.9,0,0,0,.4-.6v-6.3l-13.3,1.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M331.8,279.9a4.8,4.8,0,0,1,.4-1.2l-2.3-.6h-.2V285a1.1,1.1,0,0,0,.7,1l1.4.8v-6.9Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M332.4,287.8l-2.3-1.3a2.7,2.7,0,0,1-1-1.5v-6.9a.9.9,0,0,1,.3-.6.8.8,0,0,1,.6-.2l3,.9-.3.6a7.3,7.3,0,0,1-.5,1.2Zm-2.1-9.1v6a1.1,1.1,0,0,0,.3.6l.4.3v-6a1.3,1.3,0,0,0,.2-.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M343.8,286.9l-13.4-7.8a1.5,1.5,0,0,1,0-2.4l13.6-7.8a3.8,3.8,0,0,1,3.6,0l13.3,7.8a1.4,1.4,0,0,1,0,2.4l-13.6,7.8A3.6,3.6,0,0,1,343.8,286.9Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M345.5,288a3.4,3.4,0,0,1-2-.6l-13.4-7.8a2.1,2.1,0,0,1,0-3.6l13.7-7.8a3.8,3.8,0,0,1,4.1,0l13.3,7.8a2.1,2.1,0,0,1,1.1,1.8,2.5,2.5,0,0,1-1.1,1.8l-13.6,7.8A3.9,3.9,0,0,1,345.5,288Zm.2-18.9a2.6,2.6,0,0,0-1.5.4l-13.6,7.8a1.2,1.2,0,0,0-.5.8c0,.1,0,.4.5.7l13.3,7.8a2.8,2.8,0,0,0,2.8,0l13.6-7.8a1,1,0,0,0,.5-.7.8.8,0,0,0-.5-.8L347,269.5A1.6,1.6,0,0,0,345.7,269.1Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="b" d="M337,277.8l7,4,4.2-2.4-7-4.2Z" transform="translate(-0.6 -0.4)" />
      <path
        class="c"
        d="M344,282.6l-8.2-4.8,5.4-3.2,8.2,4.8Zm-5.6-4.8,5.8,3.3,2.8-1.7-5.6-3.3Z"
        transform="translate(-0.6 -0.4)"
      />
    </g>
    <g class="access">
      <path
        class="c"
        d="M34.4,165l-.8-.5L7.2,179.8l.7.5,10.8-6.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="c" d="M36.3,166.2l-.7-.5L9.3,181l.7.5Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M38.4,167.4l-.7-.5L11.2,182.2l.8.5Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M40.4,168.6l-.6-.5L13.3,183.4l.7.5Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M42.4,169.8l-.7-.5L15.2,184.6l.8.5Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M44.4,171l-.8-.5L17.3,185.8l.8.5Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M46.5,172.2l-.8-.5L19.3,187l.7.5Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M48.4,173.4l-.7-.5L21.4,188.2l.7.5Z" transform="translate(-0.6 -0.4)" />
      <path
        class="c"
        d="M49.9,174.3l-.3-.2L23.2,189.4l.6.3h.1l26.3-15.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M51,175.8,25.9,190.3h1.4l23.5-13.5A1.8,1.8,0,0,0,51,175.8Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M24.4,160.5.7,174.1a2.8,2.8,0,0,0-.1.9l25.3-14.5Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M27.6,161.1h0L1.2,176.2c.1.2.3.2.4.3l.3.2,26.5-15.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="c" d="M30.3,162.6l-.7-.3L3.1,177.6l.8.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M32.3,163.8l-.8-.3L5.2,178.8l.6.3Z" transform="translate(-0.6 -0.4)" />
      <path
        class="a"
        d="M22.7,181.2,4.2,170.4a1.2,1.2,0,0,1-.5-.6v-5.7a.3.3,0,0,1,.3-.3l9.3-.2h.1l9.2-5a2.6,2.6,0,0,1,2.4-.2l9.2,5.5h9.4a.3.3,0,0,1,.3.3v5.7a.6.6,0,0,1-.6.7L25.1,181A2.3,2.3,0,0,1,22.7,181.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M23.8,182.1a4.9,4.9,0,0,1-1.4-.3L3.9,171a1.5,1.5,0,0,1-.8-1.2v-5.7a1,1,0,0,1,.9-.9l9.3-.2,9-5a3.2,3.2,0,0,1,3-.2l9.1,5.4,9.1-.2c.3,0,.4.2.6.3l.3.6v5.7c0,.6-.3.9-.9,1.4L25.3,181.5A1.9,1.9,0,0,1,23.8,182.1Zm-.8-1.4a2.3,2.3,0,0,0,1.8-.1L43,170.1l.3-.3v-5.3H34.1l-9.3-5.5a2.3,2.3,0,0,0-1.8.1l-9.1,5.1H4.5v5.3h.1Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M35.6,163.9h8a.3.3,0,0,1,.3.3v5.7a.8.8,0,0,1-.6.8l-18,10.5h-.2v-5.9C24.5,173.2,35.6,163.9,35.6,163.9Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M25.3,181.8l-.5-.2a.9.9,0,0,1-.3-.6v-5.8c-.3-2.3,6.4-8.3,10.6-11.7l.2-.2h8.3c.3,0,.5.2.8.3a1.9,1.9,0,0,1,.3.8v5.7c0,.6-.3.9-.9,1.3Zm.6-6.5v4.8l17.3-9.9c.1-.1.3-.1.3-.3v-5.2H35.9c-5,4.2-10,9.1-10,10.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M43.6,163.2,25.1,152.4a2.6,2.6,0,0,0-2.4.2L4.5,163c-.8.5-.8,1.1-.2,1.4l18.6,10.8a2.6,2.6,0,0,0,2.4-.2l18.2-10.5C44.1,164.1,44.2,163.5,43.6,163.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M23.8,176.1a4.9,4.9,0,0,1-1.4-.3L3.9,165a1.5,1.5,0,0,1-.8-1.2,1.6,1.6,0,0,1,.9-1.4L22.3,152a3.2,3.2,0,0,1,3-.2l18.5,10.8a1.5,1.5,0,0,1,.7,1.2,1.6,1.6,0,0,1-.9,1.3L25.4,175.6A2.8,2.8,0,0,1,23.8,176.1ZM4.5,163.8,23,174.6a2.9,2.9,0,0,0,1.8-.2L43,163.9c.2-.1.3-.1.3-.3h-.1L24.7,152.9a2.3,2.3,0,0,0-1.8.1L4.6,163.5Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="c" d="M7.2,166.6,7,172.4H8.2l.2-5.9Z" transform="translate(-0.6 -0.4)" />
      <path class="a" d="M38.4,167.9V173h1.1v-5.1Z" transform="translate(-0.6 -0.4)" />
      <path
        class="b"
        d="M18.5,154.8l-4-2.4H14l-4.9,3.2q-.2,0,0,.3l4.8,5v1.8c0,.5,1.9-.9,2.2-.7l-2.4,1.5H14l5-3.1a2,2,0,0,0,.1-.5v-3.7A1.2,1.2,0,0,0,18.5,154.8Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M13.9,164.4h-.2a.5.5,0,0,1-.4-.5l-.3-.6.3-.3v-1.9l-4.8-4.9a.8.8,0,0,1,.3-1.2l4.9-3.2a2.1,2.1,0,0,1,1.1,0l4,2.4a2.2,2.2,0,0,1,1.1,1.8v3.9a1.7,1.7,0,0,1-.3.9h-.2l-4.9,3.2A.8.8,0,0,1,13.9,164.4Zm-4-8.5,4.4,4.8c.2.1.2.2.2.4v.9s.1,0,.1-.2,1.4-.6,1.8-.4l2.1-1.3V156a.8.8,0,0,0-.3-.7l-4-2.4Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M10.3,160.2v.3l3.4,3h.5l4.9-2.9a1.2,1.2,0,0,0,.2-.5v-3.7a.2.2,0,0,0-.2-.2l-4.9,3.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M14,164.2h-.3a.7.7,0,0,1-.5-.3l-3.6-3.1v-1l4.2-.9,4.9-3.2h.8a.9.9,0,0,1,.4.6v3.8a1.6,1.6,0,0,1-.3.8v.2l-5,3Zm-2.6-3.5,2.6,2.2,4.7-2.8v-3l-4.1,2.5v.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M13.4,163.8l-4-2.4a1.6,1.6,0,0,1-.6-1.2v-4c0-.5.3-.8.6-.5l4,2.4a1.7,1.7,0,0,1,.6,1.2v3.9C14,163.8,13.7,163.9,13.4,163.8Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M13.7,164.5h-.5L9.1,162a2.1,2.1,0,0,1-1-1.8v-4c0-.5.1-.9.6-1.1h1l4,2.4a2.2,2.2,0,0,1,1.1,1.8v3.9a1,1,0,0,1-.6,1C14,164.4,13.9,164.5,13.7,164.5Zm0-1.3-.3.6Zm-4.4-6.7v3.7a.8.8,0,0,0,.3.7l3.7,2.3v-3.7a1.1,1.1,0,0,0-.3-.8Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="a" d="M18.7,158.3,14.3,161l.6.9,4.3-2.7Z" transform="translate(-0.6 -0.4)" />
    </g>
    <g class="access">
      <path class="c" d="M248.2,277.6l-20.1,11.7.6.5L249,278.1Z" transform="translate(-0.6 -0.4)" />
      <path
        class="c"
        d="M222.2,285.6c.2.3.2.4.5.6l20.2-11.7a1.6,1.6,0,0,0-.9-.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="c" d="M223.9,286.9l.7.5L245,275.7l-.8-.5Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M226,288.1l.7.5,20.2-11.7-.7-.5Z" transform="translate(-0.6 -0.4)" />
      <path
        class="c"
        d="M232.4,299l6.1-3.6.3.2L259,283.9l-.7-.4-13.8,8.1-.3-.2-12.1,7-27.9,16.2.6.5Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M240.8,296.6c.1,0,.1.2.3.2l19.7-11.4c0-.3-.1-.4-.4-.6l-13.8,7.9h-.1l-40.1,23.2v.2l.6.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="c" d="M249,294.1l-.8-.3-40,23.2.7.5Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M251.1,295.3l-.8-.3-40,23.1v.3h.5Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M253,296.5l-.7-.5-40.1,23.3.8.4Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M255.1,297.7l-.7-.5-40.1,23.3.6.4Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M257.1,298.9l-.6-.5-40.2,23.3.7.4Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M259.2,300.1l-.8-.5-40,23.3h.1l.6.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M261.2,301.3l-.7-.5-40.2,23.3.7.4Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M263.3,302.5l-.7-.5-40.1,23.2v.2l.6.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M265.3,303.7l-.8-.5-40,23.2.7.5Z" transform="translate(-0.6 -0.4)" />
      <path
        class="c"
        d="M266.8,305.2c-.2-.2-.3-.5-.5-.6l-39.7,23v.2c.2.1.5.1.6.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M267.1,306.4l-37.8,21.8h1.5l36-20.8A2.9,2.9,0,0,0,267.1,306.4Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M230.5,290.8l.3.2,20.1-11.7-.7-.5-14.8,8.6h-.5l-37,21.4v.9Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M232.6,292h.3L253,280.5l-.7-.5-13.9,8.1h-.3l-39.8,22.9c.2.1.3.4.5.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M200.7,312.7,234.5,293l.3.2L255,281.5l-.8-.4-13.9,8.1V289L200,312.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M236.6,294.2v.2l20.4-11.7-.8-.4-13.9,8.1v-.2l-40.2,23.2.7.5Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M226.7,317l-28.8-16.8a.7.7,0,0,1-.5-.6v-5.7l.3-.3,19.5-5.8h.1l9.1-5.1a2.9,2.9,0,0,1,2.4-.1l19.6,11.5h.1l9.3-.2a.3.3,0,0,1,.3.3v5.7a.8.8,0,0,1-.6.8L229.1,317A2.5,2.5,0,0,1,226.7,317Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M227.8,317.9a2.9,2.9,0,0,1-1.4-.3l-28.7-16.8a1.5,1.5,0,0,1-.7-1.2v-5.7a1.1,1.1,0,0,1,.7-.9l19.5-5.8,8.9-5.1a2.9,2.9,0,0,1,3-.1l19.4,11.3h9.2a.7.7,0,0,1,.6.3,1.1,1.1,0,0,1,.3.6v5.7c0,.6-.3.9-.9,1.3l-28.4,16.4A3.1,3.1,0,0,1,227.8,317.9Zm-.8-1.3a2.9,2.9,0,0,0,1.8-.2l28.4-16.3.3-.3v-5.3h-9.3l-19.5-11.5a2.3,2.3,0,0,0-1.8.1l-9.1,5.1c-.2,0-.2.2-.3.2l-19.2,5.8v5.4s0,.1.2.1Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M249.6,293.9h8.1a.5.5,0,0,1,.3.3v5.7a.9.9,0,0,1-.6.8l-28.3,16.2H229V311C228.4,309.1,249.6,293.9,249.6,293.9Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M229.1,317.6h-.4a.7.7,0,0,1-.3-.6V311c-.2-.6.1-2.1,10.1-9.7,5.1-3.9,10.5-7.8,10.5-7.8v-.2h8.4c.3,0,.5.2.8.3a1.9,1.9,0,0,1,.3.8v5.7c0,.6-.3.9-.9,1.3Zm.6-6.4V316l27.4-15.8c.1-.1.3-.1.3-.3v-5.2h-7.7c-9.5,6.7-19.4,14.7-20,16.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M257.7,293.2,229,276.4a2.6,2.6,0,0,0-2.4.2l-28.4,16.3c-.8.4-.8,1-.2,1.3L226.7,311a2.9,2.9,0,0,0,2.4-.1l28.4-16.4C258.1,294.2,258.3,293.5,257.7,293.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M227.8,311.9a2.9,2.9,0,0,1-1.4-.3l-28.7-16.8a1.5,1.5,0,0,1-.7-1.2,1.6,1.6,0,0,1,.9-1.3L226.3,276a3.2,3.2,0,0,1,3-.2L258,292.6a1.5,1.5,0,0,1,.7,1.2,1.6,1.6,0,0,1-.9,1.3l-28.4,16.4A2.7,2.7,0,0,1,227.8,311.9Zm-29.6-18.3L227,310.4a2.3,2.3,0,0,0,1.8-.1l28.4-16.4c.2-.1.3-.1.3-.3h-.1l-28.7-16.7a2.3,2.3,0,0,0-1.8.1l-28.4,16.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="c" d="M200.9,296.4v5.9h1.1l.2-5.8Z" transform="translate(-0.6 -0.4)" />
      <path class="a" d="M252.4,297.9V303h1.1v-5.1Z" transform="translate(-0.6 -0.4)" />
      <path
        class="b"
        d="M216.3,307.9l-4.1-2.4a.2.2,0,0,0-.4,0l-5,3.1c-.1,0-.1.2,0,.3l4.8,5.1v1.8c0,.5,2-.9,2.3-.7l-2.4,1.5h.3l4.9-3.2a1.5,1.5,0,0,0,.2-.4v-3.9A1.1,1.1,0,0,0,216.3,307.9Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M211.6,317.3h-.1c-.2,0-.5-.1-.5-.4l-.3-.6.3-.3v-2l-4.8-5.1a1,1,0,0,1,.3-1.2l5-3.1a.9.9,0,0,1,1,0l4.1,2.4a2,2,0,0,1,1,1.8v3.9a2.2,2.2,0,0,1-.3.9h-.1l-5,3.2C211.9,317.3,211.8,317.3,211.6,317.3Zm-4-8.5,4.5,4.8c0,.1.1.3.1.4v.9h.2a2.3,2.3,0,0,1,1.8-.5l2.1-1.3v-4.1a1.1,1.1,0,0,0-.3-.7l-4.1-2.4Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M208,313.3v.3l3.5,3h.4l5-3v-4.2a.1.1,0,0,0-.1-.1l-5,3.1Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M211.8,317.3h-.3a.7.7,0,0,1-.6-.3l-3.8-3.1.2-1.1,4.2-.9,4.9-3.1a.6.6,0,0,1,.8,0,.6.6,0,0,1,.4.6v3.7a1.7,1.7,0,0,1-.3.9v.2l-5,3Zm-2.7-3.6,2.7,2.3,4.6-2.9h0v-2.9l-4,2.6h0Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M211.2,316.9l-4.1-2.4a1.7,1.7,0,0,1-.6-1.2v-3.9c0-.5.3-.8.6-.5l4.1,2.4a1.7,1.7,0,0,1,.6,1.2v3.9A.5.5,0,0,1,211.2,316.9Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M211.5,317.5c-.2,0-.5,0-.6-.2l-4.1-2.4a2,2,0,0,1-1-1.8v-3.9a1,1,0,0,1,.6-1,.9.9,0,0,1,1,0l4.1,2.4a2,2,0,0,1,1,1.8v3.9c0,.4-.1.9-.6,1A.4.4,0,0,1,211.5,317.5Zm0-1.2-.3.6Zm-4.5-6.9v3.7a1.1,1.1,0,0,0,.3.8l3.7,2.2v-3.7a1.1,1.1,0,0,0-.3-.8Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="a" d="M216.4,311.4l-4.3,2.6.5.9,4.4-2.6Z" transform="translate(-0.6 -0.4)" />
      <path
        class="a"
        d="M231.2,291.3l-18.4-10.8a.9.9,0,0,1-.4-.6v-5.7a.3.3,0,0,1,.3-.3l9.2-.2h.2l9.1-5.1a2.9,2.9,0,0,1,2.4-.1l9.3,5.5h9.4a.3.3,0,0,1,.3.3v5.7a.7.7,0,0,1-.6.7l-18.2,10.5A3,3,0,0,1,231.2,291.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M232.3,292a2.9,2.9,0,0,1-1.4-.3l-18.5-10.8a1.4,1.4,0,0,1-.8-1.2V274a1.1,1.1,0,0,1,.9-.9h9.3l9-5.1a3.2,3.2,0,0,1,3-.2l9.1,5.4H252a.7.7,0,0,1,.6.3,1.1,1.1,0,0,1,.3.6v5.7c0,.6-.3.9-.9,1.3l-18.2,10.5C233.5,292,232.9,292,232.3,292Zm-.8-1.3a2.9,2.9,0,0,0,1.8-.2L251.5,280c.2-.1.3-.1.3-.3v-5.2h-9.2l-9.3-5.6a3,3,0,0,0-1.8.2l-9.1,5.1H213v5.3h.1Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M244.1,273.9h8a.3.3,0,0,1,.3.3v5.7a.6.6,0,0,1-.6.7l-18,10.5h-.2v-5.8C233,283.2,244.1,273.9,244.1,273.9Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M233.8,291.7h-.5c-.1-.2-.3-.3-.3-.6v-5.9c-.3-2.2,6.4-8.2,10.6-11.7h8.5a1.3,1.3,0,0,1,.8.3,1.1,1.1,0,0,1,.3.7V280c0,.6-.3.9-.9,1.4Zm.5-6.4v4.8l17.4-9.9c.1-.2.3-.2.3-.3v-5.3h-7.6c-5,4.2-10.1,9.2-10.1,10.4Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M252.1,273.1l-18.5-10.8a2.6,2.6,0,0,0-2.4.2L213,273c-.8.4-.8,1-.2,1.3l18.6,10.8a2.9,2.9,0,0,0,2.4-.1L252,274.5C252.7,274.2,252.7,273.6,252.1,273.1Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M232.4,286a2.8,2.8,0,0,1-1.3-.3l-18.6-10.8a1.5,1.5,0,0,1-.7-1.2,1.6,1.6,0,0,1,.9-1.3l18.2-10.5a3.2,3.2,0,0,1,3-.2l18.5,10.8a1.5,1.5,0,0,1,.8,1.2,1.6,1.6,0,0,1-.9,1.4L234,285.6A2.7,2.7,0,0,1,232.4,286Zm-19.3-12.3h0l18.6,10.8a2,2,0,0,0,1.7-.1l18.3-10.5.3-.3h-.2l-18.5-10.8a2.3,2.3,0,0,0-1.8.1l-18.2,10.5Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="c" d="M215.7,276.5l-.2,5.8h1.2l.2-5.9Z" transform="translate(-0.6 -0.4)" />
      <path class="a" d="M246.9,277.8v5h1.1v-5.1Z" transform="translate(-0.6 -0.4)" />
      <path
        class="a"
        d="M232.1,279.3l-3.7-.6.4-1.1-1-.4-.9-.8-1.7.3-1.2-2.5,1.8-.3a2.8,2.8,0,0,1,.6-1.5l-1.3-.8,3-1.8,1.2.8a9.4,9.4,0,0,1,3-.5l.4-.9,3.7.6-.4,1.1,1,.4.9.8,1.7-.3,1.2,2.5-1.8.3a2.8,2.8,0,0,1-.6,1.5l1.3.8-3,1.8-1.2-.8a9.3,9.3,0,0,1-2.9.5Zm-2.4-1.4,1.8.3.5-.9h.3a10.8,10.8,0,0,0,3.2-.4h.2l1,.6,1.1-.6-1.1-.6.5-.5a2.4,2.4,0,0,0,.7-1.6v-.5h1.4l-.3-.8-1.5.3h-.2l-.9-.8-1.3-.6h-.6l.4-.9-1.7-.3-.5.9h-.3a11.9,11.9,0,0,0-3.3.4v.2l-1.1-.6-1,.6,1,.6-.4.4a2.5,2.5,0,0,0-.8,1.7v.4l-1.3.2.3.7,1.5-.3v.2a2.8,2.8,0,0,0,.9.7,3.7,3.7,0,0,0,1.4.6l.6.2Zm2.7-1.6a3.7,3.7,0,0,1-2.5-.9,1.8,1.8,0,0,1-.5-1.1,1.4,1.4,0,0,1,.5-1,3.9,3.9,0,0,1,5,0,1.6,1.6,0,0,1,.5,1,1.4,1.4,0,0,1-.5,1.1A3.3,3.3,0,0,1,232.4,276.3Zm0-3c-.7,0-1.5.1-1.8.6a.6.6,0,0,0-.1.4c0,.2.1.3.1.5a3.5,3.5,0,0,0,3.7,0,.6.6,0,0,0,.2-.5c0-.1-.2-.3-.2-.4A2.3,2.3,0,0,0,232.4,273.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M236.9,270.4l-1.5-.6.4-.9-2.6-.4-.5.9a7.6,7.6,0,0,0-3.4.6l-1.2-.6-2.1,1.2,1.2.6a2.8,2.8,0,0,0-.9,1.9l-1.5.3.7,1.7,1.7-.3,1,.9a6.7,6.7,0,0,0,1.5.6l-.4.9,2.7.4.4-.9a7.6,7.6,0,0,0,3.4-.6l1.2.6,2.1-1.2-1.2-.6a2.8,2.8,0,0,0,.9-1.9l1.5-.3-.7-1.7-1.7.3Zm-2.3,3.3a3.8,3.8,0,0,1-4.3,0,1.1,1.1,0,0,1,0-1.5c1.1-.9,3.5-.9,4.3,0A.9.9,0,0,1,234.6,273.7Z"
        transform="translate(-0.6 -0.4)"
      />
    </g>
    <g>
      <path class="c" d="M144.3,223.2l-9.6,5.3.4.6,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M146.2,224.2l-9.5,5.3.3.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M148,225.4l-9.5,5.3.3.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M150,226.5l-9.6,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M151.7,227.5l-9.5,5.3.3.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M153.6,228.6l-9.5,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M155.5,229.8l-9.6,5.3.4.6,9.5-5.2Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M157.6,230.8l-9.6,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M159.4,232l-9.6,5.3.4.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M160.4,233.5l-8.6,4.7.4.7,8.6-4.8Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M171.7,229.4l-18.1,10,.3.7L172.1,230Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M173.8,230.4l-18.1,10,.3.7L174.2,231Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M174.6,232l-16.3,9,.4.6,16.2-8.9Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M176.1,233.4l-14.7,8.2.3.7,14.8-8.2Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M113.9,205.7l-9.6,5.3.4.6,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M115.9,206.9l-9.5,5.3.3.6,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M117.6,207.9l-9.5,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M119.6,209l-9.5,5.3.3.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M121.4,210.1l-9.5,5.3.3.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M123.3,211.2l-9.5,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M125.1,212.3l-9.5,5.3.3.6,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M127.1,213.4l-9.6,5.3.4.6,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M129,214.5l-9.5,5.3.3.6,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M131,215.6l-9.6,5.3.4.6,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M132.8,216.8l-9.5,5.3.3.6,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M134.9,217.8l-9.6,5.3.4.6,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M136.5,218.9l-9.6,5.3.4.6,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M138.4,219.9l-9.5,5.3.3.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M140.2,221.1l-9.5,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M142.3,222.1l-9.5,5.3.3.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M144.1,223.2l-9.6,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M89.7,193.3l-6,3.4.3.6,6-3.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M92.7,193.9l-8.4,4.6.4.7,8.3-4.7Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M94.9,194.6l-9.5,5.3.3.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M97,195.7l-9.5,5.2.3.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M98.8,196.8l-9.5,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M100.9,197.9l-9.5,5.3.3.6,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M102.7,198.9l-9.6,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M104.6,200l-9.5,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M106.3,201.2l-9.5,5.3.3.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M108.4,202.2l-9.6,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M110.2,203.4l-9.5,5.3.3.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M112.2,204.5l-9.6,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M194.1,234.2l-9.6,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M196,235.3l-9.5,5.3.3.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M197.8,236.4l-9.6,5.3.4.6,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M199.7,237.5l-9.5,5.3.3.6,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M201.5,238.6l-9.5,5.3.3.6,9.6-5.2Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M203.4,239.7l-9.5,5.3.4.6,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M205.3,240.9l-9.6,5.3.4.6,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M207.4,241.9l-9.6,5.3.4.6,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M209.1,242.9l-9.5,5.3.3.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M211.1,244l-9.6,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M212.9,245.2l-9.6,5.3.4.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M215,246.2l-9.6,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M215.8,247.8l-7.7,4.3.4.6,7.7-4.2Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M211.5,253.4l-.3-.6,4.6-2.7.3.6Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M163.7,216.7l-9.6,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M165.6,217.8l-9.5,5.3.3.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M167.5,219l-9.6,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M169.4,220.1l-9.5,5.3.3.6,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M171.1,221.1l-9.5,5.3.3.6,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M173.1,222.3l-9.5,5.3.4.6,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M174.9,223.4l-9.5,5.2.3.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M178.8,225.5l-7,3.9.3.7,7.1-3.9Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M180.9,226.5l-7,3.9.3.7,7.1-3.9Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M182.7,227.7l-8.1,4.4.4.6,8-4.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M176.5,234l-.4-.6,8.5-4.6.4.6Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M186.3,229.9l-9.6,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M188.2,231l-9.5,5.3.3.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M190,232.2l-9.5,5.3.4.6,9.5-5.2Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M192.1,233.1l-9.6,5.3.4.6,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M193.9,234.3l-9.6,5.3.4.6,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M139.5,204.4l-6,3.3.3.7,6-3.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M142.4,204.8l-8.4,4.7.4.6,8.4-4.6Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M144.7,205.7l-9.5,5.3.3.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M146.8,206.7l-9.5,5.3.3.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M148.6,207.8l-9.6,5.3.4.6,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M150.7,208.8l-9.6,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M152.5,210l-9.6,5.3.4.6,9.5-5.2Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M154.4,211.1l-9.5,5.3.3.6,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M156.1,212.3l-9.5,5.3.3.6,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M158.2,213.3l-9.6,5.3.4.6,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M159.9,214.4l-9.5,5.3.4.6,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M161.9,215.4l-9.6,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M115.9,187.1l-9.6,5.3.4.6,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M117.8,188.2l-9.5,5.3.4.6,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M119.6,189.2l-9.6,5.3.4.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M121.7,190.2l-9.6,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M123.3,191.4l-9.5,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M125.3,192.5l-9.6,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M127.1,193.7l-9.5,5.3.3.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M129.2,194.7l-9.5,5.3.3.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M131,195.8l-9.6,5.3.4.6,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M132.9,196.9l-9.5,5.3.3.6,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M134.7,198.1l-9.5,5.3.3.6,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M136.8,199.1l-9.5,5.3.3.6,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M137.7,200.7l-7.7,4.2.3.7,7.7-4.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M133.3,206.2l-.3-.6,4.6-2.7.5.6Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M85.5,169.6,76,174.9l.3.6,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M87.5,170.6l-9.6,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M89.3,171.8l-9.6,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M91.4,172.8l-9.6,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M93,173.9l-9.6,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M95,175.1l-9.6,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M96.7,176.2l-9.5,5.3.4.6,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M98.8,177.2l-9.5,5.3.3.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M100.7,178.4l-9.6,5.3.4.6,9.5-5.2Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M102.6,179.5l-9.5,5.3.3.6,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M104.4,180.6l-9.6,5.3.4.6,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M106.4,181.6l-9.5,5.3.4.6,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M108.1,182.8l-9.5,5.3.3.6,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M110,183.8l-9.5,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M111.9,185l-9.6,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M113.9,185.9l-9.6,5.3.4.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M115.7,187.1l-9.5,5.3.3.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M61.3,157.2l-6,3.4.4.6,6-3.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M64.2,157.7l-8.3,4.6.3.7,8.4-4.7Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M66.7,158.5l-9.6,5.3.4.6,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M68.7,159.6l-9.6,5.3.4.6,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M70.4,160.6l-9.5,5.3.3.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M72.5,161.6l-9.6,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M74.3,162.8l-9.5,5.3.3.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M76.3,163.9l-9.6,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M77.9,165.1l-9.5,5.3.4.7,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M80,166.1l-9.5,5.3.3.7,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M81.8,167.2l-9.6,5.3.4.6,9.5-5.3Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M83.7,168.3l-9.5,5.3.3.6,9.6-5.3Z" transform="translate(-0.6 -0.4)" />
      <path
        class="c"
        d="M80.4,180.7l6.7.2c.2,0,.3,0,.3-.2l25.7-14.8c1.7-.9,4.1-1.1,5.4-.2L177,199.6h.1l19.4,6.6a.6.6,0,0,1,.5.6v4.9a2.2,2.2,0,0,1-1.2,2.1l-32.3,18.3a5.7,5.7,0,0,1-5.4.1L80.7,187.5a1.6,1.6,0,0,1-.9-1.4v-4.8C79.8,180.9,80.1,180.6,80.4,180.7Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M157.8,232.8,80.4,188.1a2.5,2.5,0,0,1-1.2-2v-4.8a1.4,1.4,0,0,1,.5-.9.9.9,0,0,1,.9-.3l6.7.2L113,165.4a6.1,6.1,0,0,1,6-.1l58.4,33.8,19.4,6.6a1.3,1.3,0,0,1,.9,1.2v4.8a2.7,2.7,0,0,1-1.6,2.7L164,233a6.6,6.6,0,0,1-3.3.9A22.4,22.4,0,0,1,157.8,232.8Zm-44.2-66.5L87.9,181.2H80.6v4.9c0,.5.3.6.6.8l77.4,44.7c1.2.8,3.3.6,4.8-.1l32.1-18.6a1.7,1.7,0,0,0,1-1.3v-5.1l-19.4-6.6-.3-.2-58.4-33.8a4.2,4.2,0,0,0-2-.5A10.2,10.2,0,0,0,113.6,166.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M80.7,182.2,158.1,227a6.8,6.8,0,0,0,5.4-.1l32.1-18.6c1.7-.9,1.8-2.3.5-3.2l-77.4-44.7a6,6,0,0,0-5.4.1L81.2,179.1C79.5,180,79.4,181.3,80.7,182.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M157.8,227.4,80.4,182.7a2.5,2.5,0,0,1-1.2-2c0-.9.6-1.6,1.7-2.2L113,159.9a6.1,6.1,0,0,1,6-.1l77.4,44.7a2.5,2.5,0,0,1,1.2,2c0,.9-.6,1.6-1.7,2.2l-32.1,18.6a6.3,6.3,0,0,1-3.3.9A5,5,0,0,1,157.8,227.4Zm-44.2-66.5L81.3,179.7c-.6.3-1,.7-1,1.2a.9.9,0,0,0,.6.7l77.4,44.8a5.8,5.8,0,0,0,4.8-.1l32.1-18.6a1.6,1.6,0,0,0,1-1.2c0-.3-.3-.6-.6-.8l-77.4-44.8a5.8,5.8,0,0,0-1.9-.4A4.8,4.8,0,0,0,113.6,160.9Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="a" d="M161,227.9h-.9v4.6h.9Z" transform="translate(-0.6 -0.4)" />
      <path class="a" d="M193.8,209.5h-.9v4.6h.9Z" transform="translate(-0.6 -0.4)" />
      <path class="a" d="M83.7,183.9h-.9v4.6h.9Z" transform="translate(-0.6 -0.4)" />
      <path
        class="b"
        d="M47.8,4.6V4.3l5.7-3.2a.9.9,0,0,1,1.2,0L228.4,101.6a4.2,4.2,0,0,1,1.6,3.3V238.1a1.7,1.7,0,0,1-.4,1.3l-6.2,3.3-5.9-7.3,2.4-1.1L54.8,138.9a4.4,4.4,0,0,1-1.6-3.3V11.9Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M216.6,235.2l1.9-.9L54.6,139.4a4.4,4.4,0,0,1-2-3.8V12.1L47.4,5c-.2-.1-.2-.4-.2-.6a1.2,1.2,0,0,1,.5-.6L53.4.7a1.4,1.4,0,0,1,1.9,0L229,101.2a4.2,4.2,0,0,1,1.9,3.7V238.1a2.5,2.5,0,0,1-.7,1.8l-6.6,3.6ZM54,1.7l-5.3,3,5.1,7.1v124a3.7,3.7,0,0,0,1.3,2.7l166.2,96.1-2.6,1.2,5.2,6.3,5.5-3c.2-.1.3-.3.3-.7V104.9a3.7,3.7,0,0,0-1.3-2.7L54.6,1.7H54Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M48.7,142.2,222.4,242.7c.9.6,1.6,0,1.6-1.3v-133a4.4,4.4,0,0,0-1.6-3.3L48.7,4.6c-.9-.6-1.6,0-1.6,1.3V139.1A3.7,3.7,0,0,0,48.7,142.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M222.1,243.3,48.4,142.8a4.2,4.2,0,0,1-1.9-3.7V5.9A2,2,0,0,1,47.4,4c.4-.3,1-.3,1.8.1L222.8,104.6a4.4,4.4,0,0,1,2,3.8V241.5a2.2,2.2,0,0,1-.9,2h-.8A1.9,1.9,0,0,1,222.1,243.3ZM48,5q-.3,0-.3.9V139.1a3.7,3.7,0,0,0,1.3,2.7L222.7,242.3h.4q.3,0,.3-.9V108.4a3.4,3.4,0,0,0-1.3-2.7L48.4,5.2c0-.2-.1-.2-.4-.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M49,139.8,222.2,240c.3.2.5,0,.5-.4v-132a1.2,1.2,0,0,0-.5-.9L49,6.5c-.3-.1-.4,0-.4.5V138.9C48.6,139.2,48.7,139.7,49,139.8Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M221.8,240.5,48.7,140.3a2,2,0,0,1-.7-1.5V6.8a1,1,0,0,1,.4-.9,1.4,1.4,0,0,1,.9,0L222.5,106.1a1.8,1.8,0,0,1,.8,1.5v132a1.1,1.1,0,0,1-.5.9h-1ZM49.2,138.8v.4l172.8,99.9V107.6l-.2-.4L49.2,7.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M47.1,139.2v-7.6L224.2,234v7.7c0,1.2-.8,1.6-1.8,1L49,142.4A3.7,3.7,0,0,1,47.1,139.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M221.9,243.2,48.6,142.8a4.5,4.5,0,0,1-2.1-3.7v-8.7l178,103,.3.2v7.9a1.8,1.8,0,0,1-.9,1.7h-.8A1.1,1.1,0,0,1,221.9,243.2ZM47.7,132.6v6.6a3.9,3.9,0,0,0,1.5,2.7L222.5,242.3h.8a.9.9,0,0,0,.3-.6v-7.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="a" d="M124.6,180.8l-.4.8,22.4,13,.4-.8Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M229.8,102.5l-5.9,3.6.7,1,5.8-3.5Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M64.2,6.2,58.3,9.7l.6,1.1,5.9-3.6Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M229.8,228.6l-5.9,3.6.6,1,5.9-3.5Z" transform="translate(-0.6 -0.4)" />
      <path class="a" d="M182.5,220.9l.4-.8-3.7-2.2-.4.9Z" transform="translate(-0.6 -0.4)" />
      <path
        class="c"
        d="M160.8,224.6a2.3,2.3,0,0,0,1.8-.6l6.7-4.2-.6-1L162,223a2.5,2.5,0,0,1-2.4,0L93,184.8l-.6,1L159,224A2.6,2.6,0,0,0,160.8,224.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M90.4,184.9l.6-1-4.9-2.7-.2-.3s0-.3.2-.3l6.9-4.1-.6-1-6.9,4a1.6,1.6,0,0,0-.8,1.5,1.6,1.6,0,0,0,.9,1.5Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="c" d="M230.1,224.1l-5.9,3.6.6,1,5.9-3.5Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M67.9,8.4,62,11.9l.6,1,5.9-3.5Z" transform="translate(-0.6 -0.4)" />
      <path class="c" d="M230.1,108.8l-5.9,3.6.6,1,5.9-3.5Z" transform="translate(-0.6 -0.4)" />
      <path
        class="a"
        d="M197.1,207.4,73.4,135.6a2.6,2.6,0,0,1-1.1-2.1V32.1c0-.7.5-1.2,1.1-.9l123.7,71.6a2.7,2.7,0,0,1,1.1,2.1V206.3C198.2,207.2,197.7,207.7,197.1,207.4Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M197.6,208a1.3,1.3,0,0,1-.8-.2L73.1,136.1a3.1,3.1,0,0,1-1.4-2.6V32.1a1.8,1.8,0,0,1,.6-1.3,1.3,1.3,0,0,1,1.2,0l123.8,71.6a3.1,3.1,0,0,1,1.3,2.5V206.3a2,2,0,0,1-.6,1.4ZM72.9,31.7h0c-.1,0-.1.1-.1.4V133.5a2.1,2.1,0,0,0,.9,1.7l123.7,71.6h.3a.8.8,0,0,0,.2-.5V105.1a2.4,2.4,0,0,0-.9-1.7L73.1,31.7Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M67.3,132.2l-4.1-2.4a2.7,2.7,0,0,1-1-2.1V26.3c0-.7.4-1.2,1-.9l4.1,2.4a2.7,2.7,0,0,1,1,2.1V131.3C68.3,132.2,67.9,132.5,67.3,132.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M67.7,132.8a1.2,1.2,0,0,1-.7-.2l-4.1-2.4a3,3,0,0,1-1.3-2.5V26.3a1.8,1.8,0,0,1,.6-1.3,1.3,1.3,0,0,1,1.2,0l4,2.4a2.9,2.9,0,0,1,1.3,2.5V131.3a2.2,2.2,0,0,1-.5,1.3A.6.6,0,0,1,67.7,132.8Zm-.1-1.1c.1,0,.1.2.3,0a.6.6,0,0,0,.1-.4V29.9c0-.6-.4-1.5-.9-1.6l-4.2-2.4c-.1,0-.1-.2-.3,0a.6.6,0,0,0-.1.4V127.7c0,.6.4,1.5.9,1.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M211.6,215.6l-8.2-4.8a2.5,2.5,0,0,1-1-2.1V107.3c0-.7.4-1.2,1-.9l8.2,4.8a2.7,2.7,0,0,1,1.1,2.1V214.7C212.7,215.6,212.2,216.1,211.6,215.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M212.1,216.4a1.2,1.2,0,0,1-.8-.2l-8.2-4.8a3.1,3.1,0,0,1-1.3-2.5V107.3a1.8,1.8,0,0,1,.6-1.3,1.3,1.3,0,0,1,1.2,0l8.2,4.8a3.1,3.1,0,0,1,1.3,2.5V214.7a2,2,0,0,1-.6,1.4Zm-.3-1.1c.1,0,.1.2.3,0a.6.6,0,0,0,.1-.4V113.5a2.1,2.1,0,0,0-.9-1.7l-8.2-4.8h-.3a1.2,1.2,0,0,0-.1.5V208.9c0,.6.4,1.5.9,1.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M197.1,110.6,73.4,39a2.6,2.6,0,0,1-1.1-2.1V32.1c0-.7.5-1.2,1.1-.9l123.7,71.6a2.7,2.7,0,0,1,1.1,2.1v4.8C198.2,110.6,197.7,111.1,197.1,110.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M197.6,111.2h-.8L73.1,39.5a3.1,3.1,0,0,1-1.4-2.6V32.1a1.8,1.8,0,0,1,.6-1.3,1.3,1.3,0,0,1,1.2,0l123.8,71.6a3.1,3.1,0,0,1,1.3,2.5v4.8a2,2,0,0,1-.6,1.4ZM72.9,31.7h0c-.1,0-.1.1-.1.4v4.8a2.1,2.1,0,0,0,.9,1.7l123.7,71.6h.3a.8.8,0,0,0,.2-.5v-4.8c0-.6-.5-1.5-.9-1.6L73.1,31.7Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M190.3,102.8c0,.9-.6,1.2-1.4.8a3.2,3.2,0,0,1-1.3-2.3c0-.7.6-1.2,1.3-.7A2.6,2.6,0,0,1,190.3,102.8Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M78,38c0,.9-.6,1.2-1.3.7a2.9,2.9,0,0,1-1.4-2.2c0-.9.6-1.2,1.4-.8A2.7,2.7,0,0,1,78,38Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M194.2,106.2c.5-.3.5-1.2,0-2.1s-1.3-1.3-1.8-1-.5,1.2,0,2.1S193.7,106.5,194.2,106.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M99.1,85l-20-11.5A2.7,2.7,0,0,1,78,71.4V49.8c0-.7.5-1.2,1.1-.9l20,11.6a2.5,2.5,0,0,1,1,2.1V84C100.3,85,99.7,85.3,99.1,85Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M99.5,85.6h-.7l-20-11.6a2.9,2.9,0,0,1-1.4-2.5V49.8a1.8,1.8,0,0,1,.6-1.3,1.3,1.3,0,0,1,1.2,0L99.2,60a3.1,3.1,0,0,1,1.4,2.6V84a1.8,1.8,0,0,1-.6,1.3C100,85.6,99.8,85.6,99.5,85.6Zm-.1-1c.1,0,.1.1.3,0a1.2,1.2,0,0,0,.1-.5V62.7c0-.6-.4-1.5-.9-1.6l-20-11.6c-.1,0-.1-.1-.3,0a1.2,1.2,0,0,0-.1.5V71.4c0,.6.4,1.5.9,1.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M191.6,154.7l-12.1-7.1a2.5,2.5,0,0,1-1-2.1V107.9c0-.7.4-1.2,1-.9l12.1,7.1a2.5,2.5,0,0,1,1,2.1v37.6C192.8,154.7,192.2,155.1,191.6,154.7Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M192.1,155.4h-.8l-12.1-7.1a3.1,3.1,0,0,1-1.3-2.5V107.9a1.8,1.8,0,0,1,.6-1.3,1.1,1.1,0,0,1,1.1,0l12.2,7a3.3,3.3,0,0,1,1.3,2.6v37.6a1.8,1.8,0,0,1-.6,1.3A.5.5,0,0,1,192.1,155.4Zm-.2-1h.3a.8.8,0,0,0,.2-.5V116.2a2.4,2.4,0,0,0-.9-1.7l-12.2-7c-.1,0-.1-.2-.3,0a.6.6,0,0,0-.1.4v37.8c0,.6.4,1.5.9,1.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M191.6,162.9l-12.1-7a2.7,2.7,0,0,1-1-2.1v-1.2c0-.8.4-1.2,1-.9l12.1,7a2.7,2.7,0,0,1,1,2.1V162C192.8,162.9,192.2,163.3,191.6,162.9Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M191.5,163.3l-5.7-3.2.4-.9,5.6,3.2Zm.7-2.5a2.1,2.1,0,0,0-.9-1.5l-3.7-2.1.4-.9,3.8,2.1a3.8,3.8,0,0,1,1.3,2.1Zm-9.3-2.2-3.7-2.1a3.8,3.8,0,0,1-1.3-2.3h.9a2.4,2.4,0,0,0,.8,1.5l3.8,2.1Zm2-3-5.6-3.3.3-.5.2-.4h.1l5.6,3.1Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M191.6,197.6l-12.1-7a2.5,2.5,0,0,1-1-2.1V174.7c0-.7.4-1.2,1-.9l12.1,7.1a2.5,2.5,0,0,1,1,2.1v13.7C192.8,197.5,192.2,197.9,191.6,197.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M192.1,198.2h-.8l-12.1-7a3.3,3.3,0,0,1-1.3-2.6V174.7a1.8,1.8,0,0,1,.6-1.3,1.1,1.1,0,0,1,1.1,0l12.2,7a3.3,3.3,0,0,1,1.3,2.6v13.7a2,2,0,0,1-.6,1.4Zm-.2-1c.2,0,.2.1.3,0a.8.8,0,0,0,.2-.5V183a2.4,2.4,0,0,0-.9-1.7l-12.2-7c-.1,0-.1-.2-.3,0a.6.6,0,0,0-.1.4v13.8a2.1,2.1,0,0,0,.9,1.7Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M191.6,177l-12.1-7.1a2.5,2.5,0,0,1-1-2.1v-6.9c0-.7.4-1.1,1-.8l12.1,7a2.5,2.5,0,0,1,1,2.1v6.9C192.8,177,192.2,177.4,191.6,177Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M191.5,177.4l-5-2.8.5-.9,4.8,2.8Zm1.7-2.2h-1v-5.6h1Zm-9.1-2-4.8-2.8.2-.5.3-.4,4.8,2.8Zm-5.2-5.7h-1V162h1Zm12.4,0-4.8-2.8.5-.9,4.8,2.8-.2.5Zm-7.2-4.2-4.8-2.8.5-.9h.1l4.8,2.8Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M99.1,144l-20-11.5a2.7,2.7,0,0,1-1.1-2.1V78.9c0-.8.5-1.2,1.1-.9l20,11.5a2.7,2.7,0,0,1,1,2.1v51.5C100.3,144,99.7,144.5,99.1,144Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M98.9,144.5l.3-.5-.3.5-5-3,.4-.9,5.1,3Zm1.8-2.4h-1v-5.9h1Zm-9.4-2-5.1-3,.5-.9,5.1,3Zm-7.6-4.3-4.8-2.9h-.3l.6-.8a.2.2,0,0,1,.2.2l4.7,2.8Zm17-2.4h-1v-5.8h1Zm-22.2-3.8H77.4v-5.8h1.1Zm22.2-5h-1v-5.9h1ZM78.5,121H77.4v-5.9h1.1Zm22.2-5.1h-1V110h1Zm-22.2-3.8H77.4v-5.8h1.1Zm22.2-5.1h-1v-5.8h1Zm-22.2-3.6H77.4V97.6h1.1Zm22.2-5.1h-1V92.5h1ZM78.5,94.6H77.4V88.8h1.1Zm20.6-4.5h0L94,87.3l.5-.9,4.7,2.8c.2,0,.2.2.3.2ZM78.5,85.9H77.4V80.1h1.1Zm13-.1-5.1-3,.4-.9,5.1,3ZM84,81.4l-5.1-2.8.3-.5.2-.4h.1l5.1,2.8Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M173.4,187l-20.1-11.5a2.7,2.7,0,0,1-1-2.1V92.8c0-.7.4-1.2,1-.9l20.1,11.5a2.7,2.7,0,0,1,1,2.1v80.6C174.4,187,174,187.5,173.4,187Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M173.8,187.6h-.7L153,175.9a3.1,3.1,0,0,1-1.3-2.5V92.8a1.8,1.8,0,0,1,.6-1.3,1.3,1.3,0,0,1,1.2,0l20,11.5a2.9,2.9,0,0,1,1.4,2.5v80.6a2,2,0,0,1-.6,1.4Zm-.1-1h.3a1.2,1.2,0,0,0,.1-.5V105.7a2.1,2.1,0,0,0-.9-1.7l-20-11.5h-.3a.8.8,0,0,0-.2.5v80.5a2.4,2.4,0,0,0,.9,1.7Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M147.4,172l-2.7-1.5a2.6,2.6,0,0,1-1.1-2.1V87.9c0-.8.5-1.2,1.1-.9l2.7,1.5a2.5,2.5,0,0,1,1,2.1v80.5C148.4,171.9,148,172.3,147.4,172Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M147.8,172.6h-.7l-2.7-1.5a3.1,3.1,0,0,1-1.4-2.6V87.9a2,2,0,0,1,.6-1.4h1.2l2.7,1.5a3.1,3.1,0,0,1,1.4,2.6v80.5a2,2,0,0,1-.6,1.4Zm-.3-1h.3a.8.8,0,0,0,.2-.5V90.6a2.4,2.4,0,0,0-.9-1.7l-2.7-1.5c-.2,0-.2-.1-.3,0a.8.8,0,0,0-.2.5v80.5a2.4,2.4,0,0,0,.9,1.7Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M138.4,125.2l-33.2-19.4a2.5,2.5,0,0,1-1-2.1V64.9c0-.7.4-1.2,1-.9l33.3,19.4a2.6,2.6,0,0,1,1.1,2.1v38.8C139.6,125.2,139,125.5,138.4,125.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M138.2,125.6l.3-.4-.3.4-4.9-2.8.5-.9,4.9,2.8Zm1.8-2.4h-1v-5.7h1Zm-9.2-1.9-5-2.9.5-.9,4.9,2.9Zm-7.5-4.4-4.9-2.8.4-.9,4.9,2.8Zm16.7-2.2h-1V109h1Zm-24-2-5-3,.5-.9,4.9,2.9Zm-7.5-4.3-3.6-2.1a4.7,4.7,0,0,1-1.2-1.5l.9-.3a3.9,3.9,0,0,0,.8,1l3.6,2.1ZM140,106h-1v-5.7h1Zm-35.5-4.2h-1.1V96.1h1.1ZM140,97.4h-1V91.8h1Zm-35.5-4.1h-1.1V87.6h1.1ZM140,88.9h-1V85.6a1.9,1.9,0,0,0-.8-1.6l.6-.8a2.9,2.9,0,0,1,1.2,2.4Zm-35.5-4.3h-1.1V78.9h1.1Zm31.4-2.1-5-2.9.5-.9,4.9,2.9Zm-7.5-4.4-5-2.8.5-.9,4.9,2.8ZM104.5,76h-1.1V70.3h1.1Zm16.6-2.2-5-2.9.5-.9,4.9,2.9Zm-7.5-4.2-4.9-2.9.4-.9,4.9,2.9Zm-9.1-2.1h-1.1V64.9c0-1.3,1.1-1.8,1.8-1.2l1.2.8-.4.9-1.2-.8h-.2c-.1,0-.1.2-.1.5Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M138.4,138.3l-33.2-19.1a2.7,2.7,0,0,1-1-2.1v-5.7c0-.8.4-1.2,1-.9l33.3,19.3a2.6,2.6,0,0,1,1.1,2.1v5.7C139.6,138.3,139,138.8,138.4,138.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M138.8,139.1a1,1,0,0,1-.7-.2l-33.2-19.3a3.1,3.1,0,0,1-1.3-2.5v-5.7a2,2,0,0,1,.6-1.4h1.2l33.3,19.3a3.3,3.3,0,0,1,1.3,2.6v5.7a1.8,1.8,0,0,1-.6,1.3Zm-.1-1.1c.1,0,.1.2.3,0a.6.6,0,0,0,.1-.4v-5.7a2.1,2.1,0,0,0-.9-1.7l-33.3-19.3c-.1,0-.1-.1-.3,0a1.2,1.2,0,0,0-.1.5v5.7c0,.6.4,1.5.9,1.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M138.4,166.8l-33.2-19.2a2.5,2.5,0,0,1-1-2.1V124.3c0-.8.4-1.2,1-.9l33.2,19.3a2.5,2.5,0,0,1,1,2.1V166C139.6,166.8,139,167.2,138.4,166.8Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M138.8,167.4a1,1,0,0,1-.7-.2l-33.2-19.1a3.3,3.3,0,0,1-1.3-2.6V124.3a2,2,0,0,1,.6-1.4,2.4,2.4,0,0,1,1.2,0l33.3,19.3a3.3,3.3,0,0,1,1.3,2.6V166a2,2,0,0,1-.6,1.4Zm-.1-1.1c.1,0,.1.2.3,0a.6.6,0,0,0,.1-.4V144.8a2.1,2.1,0,0,0-.9-1.7l-33.3-19.3h-.3a1.2,1.2,0,0,0-.1.5v21.2a2.1,2.1,0,0,0,.9,1.7Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M207.9,209.6h-1.1v-.4h1.1Zm0-3.3h-1.1v-5.8h1.1Zm0-8.8h-1.1v-5.8h1.1Zm0-8.7h-1.1V183h1.1Zm0-8.8h-1.1v-5.9h1.1Zm0-8.7h-1.1v-5.9h1.1Zm0-8.9h-1.1v-5.8h1.1Zm0-8.6h-1.1v-5.9h1.1Zm0-8.9h-1.1v-5.8h1.1Zm0-8.7h-1.1v-5.8h1.1Zm0-8.8h-1.1v-5.8h1.1Zm0-8.8h-1.1v-5.9h1.1Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M58.6,124.9H57.5V119h1.1Zm0-8.9H57.5v-5.8h1.1Zm0-8.8H57.5v-5.9h1.1Zm0-8.7H57.5V92.7h1.1Zm0-8.8H57.5V83.8h1.1Zm0-8.7H57.5V75.1h1.1Zm0-8.9H57.5V66.3h1.1Zm0-8.7H57.5V57.6h1.1Zm0-8.8H57.5V48.8h1.1Zm0-8.7H57.5V40.1h1.1Zm0-8.8H57.5V31.2h1.1Zm0-8.7H57.5V22.6h1.1Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M109.7,133.4c0,.9-.6,1.2-1.3.7a2.9,2.9,0,0,1-1.4-2.2c0-.8.6-1.2,1.4-.8A3,3,0,0,1,109.7,133.4Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M82.3,55.1c0,.9-.5,1.2-1.3.7a3,3,0,0,1-1.2-2.4c0-.9.6-1.2,1.4-.7A3.2,3.2,0,0,1,82.3,55.1Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M232,152.6,211.9,141H211l-5,3,4.7,8.1v-2.5a2.7,2.7,0,0,0,1.1,2.1l10.3,6,5.2,8.6,5.3-3.1a1.9,1.9,0,0,0,.3-.9v-7.6A2,2,0,0,0,232,152.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M227.3,167.4l-.4-.6-5.1-8.5-10.2-5.9h-.7l-.5.3-5-8.4v-.6l.3-.2,5.2-3.1a1.7,1.7,0,0,1,1.4,0l20,11.5a3.6,3.6,0,0,1,1.5,2.7v7.8a1.3,1.3,0,0,1-.6,1.3Zm-17-17.7h1.2a2.9,2.9,0,0,0,.7,1.7l10.5,6h.1l5,8.2,4.6-2.8v-8.2a2.9,2.9,0,0,0-.7-1.7l-20.1-11.5h-.1l-4.7,2.8,3.3,5.7v-.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M221.3,155l.2,2.4.7.4,5.1,8.7h.2l5.1-3a1.9,1.9,0,0,0,.3-.9V155h-.2l-5.1,3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M227.8,167.1l-.6-.2-5.3-8.6-.9-.6v-2.9l.4-.7,6.8,3,5.1-3,.7.3v8a1.4,1.4,0,0,1-.6,1.4Zm-5.7-10.2.6.5h.1l5,8.2,4.6-2.8v-7l-4,2.4-.2.3-6.1-2.7Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M226.9,166.5,206.8,155a2.7,2.7,0,0,1-1-2.1v-7.8c0-.8.4-1.2,1-.9l20.1,11.5a2.7,2.7,0,0,1,1,2.1v7.8C227.9,166.5,227.5,166.8,226.9,166.5Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M227.2,167.2h-.8l-20-11.5a3.9,3.9,0,0,1-1.5-2.7v-7.8a1.8,1.8,0,0,1,.8-1.5c.4-.3.8-.2,1.3,0l20,11.5a3.6,3.6,0,0,1,1.5,2.7v7.8a2,2,0,0,1-.7,1.5Zm-20.8-22.6v8.1a2.9,2.9,0,0,0,.7,1.7l20.1,11.5h.1v-8.1a2.6,2.6,0,0,0-.7-1.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="c" d="M214.4,142.4l-4.9,3.1.6,1,5-3.1Z" transform="translate(-0.6 -0.4)" />
      <path class="a" d="M232.5,159.2l-4.3,2.7.5.9,4.3-2.7Z" transform="translate(-0.6 -0.4)" />
      <g class="company bitbucket">
        <path
          class="b"
          d="M231.8,124.4l-20-11.5a.6.6,0,0,0-.8,0h-.1l-5.1,3,4.8,8.1v11.2a2.7,2.7,0,0,0,1,2.1l10.3,6,5.3,8.7,5.2-3.2q.3-.2.3-.9V126.7A2.3,2.3,0,0,0,231.8,124.4Z"
          transform="translate(-0.6 -0.4)"
        />
        <path
          class="c"
          d="M227.5,152.7h-.6l-.2-.3-5.1-8.6-10.1-5.8a3.6,3.6,0,0,1-1.5-2.7V124.3l-5.1-8.6.6-.4,5.2-3.2c.5-.3.9-.1,1.4,0l20,11.6a3.2,3.2,0,0,1,1.5,2.7v21.4a1.5,1.5,0,0,1-.6,1.3Zm-20.8-36.5,4.6,7.8h0v11.1a2.7,2.7,0,0,0,.8,1.6l10.4,6,.2.2,4.9,8.2,4.7-2.8V126.7a3,3,0,0,0-.8-1.7l-20-11.5h-.2Z"
          transform="translate(-0.6 -0.4)"
        />
        <path
          class="b"
          d="M221.2,140.4v2.4l.8.5,5.1,8.7h.1l5.1-3a1.2,1.2,0,0,0,.3-.9V126.7h-.1l-5.1,2.9Z"
          transform="translate(-0.6 -0.4)"
        />
        <path
          class="c"
          d="M227.5,152.7H227l-.3-.3-5.1-8.6-.9-.6v-3l6.6-10.9.2-.2,5.4-3.2.7.3v21.8a1.4,1.4,0,0,1-.6,1.4Zm-5.6-10.3.6.3h.2l4.9,8.3,4.7-2.9V127.7l-4.1,2.4-6.4,10.5Z"
          transform="translate(-0.6 -0.4)"
        />
        <path
          class="c"
          d="M226.6,152l-20.1-11.6a2.8,2.8,0,0,1-1-2.1V116.8c0-.8.5-1.2,1-.9l20.1,11.5a2.7,2.7,0,0,1,1,2.1v21.4C227.8,152,227.2,152.3,226.6,152Z"
          transform="translate(-0.6 -0.4)"
        />
        <path
          class="c"
          d="M227,152.7h-.7L206.2,141a3.4,3.4,0,0,1-1.4-2.7V116.8a2,2,0,0,1,.7-1.5,1.2,1.2,0,0,1,1.3,0l20.1,11.5a3.7,3.7,0,0,1,1.5,2.7v21.4a1.8,1.8,0,0,1-.8,1.5C227.5,152.7,227.3,152.7,227,152.7Zm-20.8-36.2v21.7a2.7,2.7,0,0,0,.8,1.6l20,11.6h.2V129.6a2.7,2.7,0,0,0-.8-1.6Z"
          transform="translate(-0.6 -0.4)"
        />
        <path
          class="b"
          d="M221.6,131.3l-11.8-6.9a.3.3,0,0,0-.4.2h0l1.6,13a1,1,0,0,0,.5.8h.1l8.3,4.8c.1.1.2,0,.4-.2l.7-4.3.5-2.7-3.7-2.3-.6,3.5-2.7-1.5-.8-4.7,1.4.8,2.5,1.5,3.7,2.2.6-3.6C222.1,131.9,221.9,131.6,221.6,131.3Z"
          transform="translate(-0.6 -0.4)"
        />
        <path class="c" d="M214.3,114.3l-5,3,.7,1.1,4.9-3.1Z" transform="translate(-0.6 -0.4)" />
        <path class="c" d="M232.2,144.8l-4.3,2.6.5.9,4.4-2.6Z" transform="translate(-0.6 -0.4)" />
      </g>
      <path
        class="b"
        d="M171.1,59.3l-6.2-3.6c-.2-.2-.3-.2-.5,0l-4.9,3.1c-.2,0-.2.2,0,.3l4.8,5.1h0V66a1.7,1.7,0,0,0,.6,1.2l1.6-2-.3,2.7q0,.3.3,0l4.9-3.1a1.2,1.2,0,0,0,.2-.5V60.5A1.2,1.2,0,0,0,171.1,59.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M166.5,68.7h-.2a.5.5,0,0,1-.4-.5h-.2l.2-1.1-.8.9-.4-.3a2,2,0,0,1-1-1.8V64.3l-4.8-5a.8.8,0,0,1,.3-1.2l4.9-3.2a1.7,1.7,0,0,1,1,0l6.3,3.6a2.2,2.2,0,0,1,1.1,1.8v3.9a2.2,2.2,0,0,1-.3.9H172l-4.9,3.2A.8.8,0,0,1,166.5,68.7Zm-.2-4.4.5.3a.5.5,0,0,1,.3.3V67l4-2.5v-4a1.1,1.1,0,0,0-.3-.8l-6.2-3.6-4.4,2.7,4.5,4.8a.4.4,0,0,1,.2.4v2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M162.8,64.6v.3l3.4,3a.4.4,0,0,0,.4.2l5-3a2,2,0,0,0,.1-.5V60.9a.1.1,0,0,0-.1-.1l-5,3.1Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M166.5,68.7h-.3l-.6-.3-3.7-3.2v-1l4.2-.9,4.9-3.1a.6.6,0,0,1,.8,0,.6.6,0,0,1,.4.6v3.7a2.2,2.2,0,0,1-.3.9h-.1l-5,3Zm-2.7-3.8,2.7,2.3,4.6-2.9h0V61.4l-4,2.5h-.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M165.9,68.1l-6.3-3.6a1.7,1.7,0,0,1-.6-1.2V59.4c0-.4.3-.7.6-.4l6.3,3.6a1.4,1.4,0,0,1,.6,1.1v3.9C166.6,68.1,166.3,68.4,165.9,68.1Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M166.2,68.8h-.6l-6.3-3.6a2.1,2.1,0,0,1-1-1.8V59.4c0-.4.1-.9.6-1a.9.9,0,0,1,1,0l6.3,3.6a1.9,1.9,0,0,1,1,1.7v3.9c0,.5-.1.9-.6,1.1Zm0-1.2-.3.6Zm-6.6-8v3.7a1.1,1.1,0,0,0,.3.7l6,3.5V63.7a1.1,1.1,0,0,0-.3-.7Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="c" d="M167.2,56.6l-4.9,3.1.6,1,4.9-3.1Z" transform="translate(-0.6 -0.4)" />
      <path class="a" d="M171.1,63l-4.3,2.6.5.9,4.3-2.6Z" transform="translate(-0.6 -0.4)" />
      <path
        class="b"
        d="M215.5,85,179.3,63.9a.2.2,0,0,0-.4,0L174,67c-.2,0-.2.2,0,.3l4.8,5.1v1.8c0,.5.2,1.1.5,1.2l1.7-1.9,29.7,20.2c0,.2.2.2.3,0l5-3.1a2,2,0,0,0,.1-.5V86.2A1,1,0,0,0,215.5,85Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M210.9,94.5h-.2l-.4-.3L181,74.2l-1.7,2-.4-.3a2.1,2.1,0,0,1-1-1.8V72.6l-4.8-5.1a.8.8,0,0,1,.3-1.2l4.9-3.2a1.7,1.7,0,0,1,1,0l36.5,21.3a2.2,2.2,0,0,1,1.1,1.8v4.1a2.2,2.2,0,0,1-.3.9h-.2l-4.9,3.2ZM181.4,73l29.5,20.1,4.6-2.8V86.2a.8.8,0,0,0-.3-.7L179,64.5l-4.3,2.7,4.5,4.8a.6.6,0,0,1,.1.4v2l1.5-1.8.5.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M182.8,76.2s24.3,14.4,24.3,14.5l3.5,3a.4.4,0,0,0,.4.2l5-3a2,2,0,0,0,.1-.5V86.7c0-.2-.1-.2-.1-.2l-5,3.2L186.5,75.4Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M211,94.5h-.3l-.6-.3-3.4-3c-1.2-.9-14.9-9-24.2-14.4l-1.4-.8,5.7-1.3h.2c18.2,10.7,23,13.4,24,14.1l4.7-2.8c.3-.2.6-.2.7,0a.7.7,0,0,1,.5.6v3.6a2.2,2.2,0,0,1-.3.9h-.2l-4.9,3A.6.6,0,0,1,211,94.5Zm-3.4-4.2,3.4,2.8,4.7-2.8v-3l-4.2,2.5c-.3.2-.3.2-3.8-1.8s-9.1-5.2-21.2-12.3l-2.1.5C202.4,87,206.5,89.4,207.6,90.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M210.4,93.9,174.3,72.7a1.4,1.4,0,0,1-.6-1.2V67.6c0-.4.3-.7.6-.4l36.1,21.1a1.7,1.7,0,0,1,.6,1.2v3.9C211,93.9,210.7,94.2,210.4,93.9Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M210.7,94.6h-.6L174,73.3a2.1,2.1,0,0,1-1.1-1.8V67.6a1,1,0,0,1,.6-1,1.1,1.1,0,0,1,1.1,0l36.1,21.1a2.2,2.2,0,0,1,1.1,1.8v3.9a1.1,1.1,0,0,1-.6,1.1Zm0-1.2-.3.6ZM174.1,67.8v3.7a1.9,1.9,0,0,0,.3.8l35.9,21V89.5a1.1,1.1,0,0,0-.3-.7Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="c" d="M181.7,65l-4.9,3.1.6,1,5-3.1Z" transform="translate(-0.6 -0.4)" />
      <path class="a" d="M215.6,88.7l-4.3,2.6.5.9,4.4-2.6Z" transform="translate(-0.6 -0.4)" />
      <path
        class="b"
        d="M133.9,155.3l-13.3-7.7h-.4l-5.6,3.5q-.1,0,0,.3l5.4,5.8v2a1.3,1.3,0,0,0,.8,1.3l1.8-2.2h.1l6,6.7c0,.2.1.2.3.2l5.5-3.5a1,1,0,0,0,.3-.6v-4.3A2,2,0,0,0,133.9,155.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M128.7,165.7h-.2a.5.5,0,0,1-.4-.3l-5.5-6.1-1.8,2.1-.5-.3a2.3,2.3,0,0,1-1-1.9v-1.7l-5.4-5.7a.8.8,0,0,1,.3-1.2l5.5-3.4a1.3,1.3,0,0,1,1.2,0l13.3,7.6a2.4,2.4,0,0,1,1.1,2v4.3a1.4,1.4,0,0,1-.5,1v.2l-5.6,3.4ZM123,158l5.7,6.4,5.2-3.3v-4.5a2.5,2.5,0,0,0-.4-.9l-13.2-7.6-5.1,3.1,5.1,5.6a.4.4,0,0,1,.2.4V159a.9.9,0,0,0,.1.5l1.7-2.1.4.3C122.9,157.8,123,157.8,123,158Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M124.5,161.2v.3l3.9,3.3c.1.2.3.3.4.2l5.6-3.5a1,1,0,0,0,.3-.6v-4.1c0-.2-.2-.2-.3-.2l-5.6,3.5Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M128.7,165.7h-.3a.7.7,0,0,1-.6-.3l-4.1-3.4.2-1.2,4.6-1,5.6-3.5a.8.8,0,0,1,.7,0,1,1,0,0,1,.5.8v4.1a1.6,1.6,0,0,1-.5,1.1h-.1l-5.6,3.5C129.1,165.6,129,165.7,128.7,165.7Zm-3.2-4,3.3,2.7,5.3-3.3v-3.4l-4.7,3h-.1Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M128.1,165.1l-13.3-7.6a1.7,1.7,0,0,1-.8-1.3v-4.5c0-.6.3-.8.8-.6l13.3,7.6a1.9,1.9,0,0,1,.7,1.4v4.3C128.8,165.1,128.5,165.4,128.1,165.1Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M128.4,165.9c-.2,0-.5,0-.6-.2l-13.3-7.6a2.4,2.4,0,0,1-1.1-1.9v-4.5a1.4,1.4,0,0,1,.6-1.2,1.1,1.1,0,0,1,1.1,0l13.3,7.6a2.3,2.3,0,0,1,1,2v4.3a1.3,1.3,0,0,1-.6,1.2A.4.4,0,0,1,128.4,165.9Zm-13.6-14.1v4.4a2.5,2.5,0,0,0,.4.9l13,7.4v-4.3a2.5,2.5,0,0,0-.4-.9Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="c" d="M123.4,148.8l-5.6,3.5.6,1,5.6-3.5Z" transform="translate(-0.6 -0.4)" />
      <path class="a" d="M133.8,159.5l-4.8,2.9.5.9,4.9-2.9Z" transform="translate(-0.6 -0.4)" />
      <g class="company gitlab">
        <path
          class="b"
          d="M133.3,87.4,78.6,55.8h-.9l-5.5,3.3a.6.6,0,0,0-.2.5l5.3,9.1h0v48a3.5,3.5,0,0,0,1.2,2.4L123,144.8h.2l5,9a.6.6,0,0,0,.5.2l5.5-3.3a1.2,1.2,0,0,0,.5-1.1V89.8A4.8,4.8,0,0,0,133.3,87.4Z"
          transform="translate(-0.6 -0.4)"
        />
        <path
          class="c"
          d="M128.5,154.5h-.3c-.3,0-.4-.1-.6-.4l-5-9L78.2,119.5a3.6,3.6,0,0,1-1.5-3V68.8l-5.1-8.9c-.3-.5-.2-1.1.3-1.2l5.5-3.3a1.4,1.4,0,0,1,1.5,0l54.7,31.4a3.6,3.6,0,0,1,1.5,3v59.8a2.3,2.3,0,0,1-.6,1.5l-5.5,3.3ZM72.8,59.4l4.9,8.8a.6.6,0,0,1,.2.5v47.9a2.1,2.1,0,0,0,.9,1.8L123.3,144c.1.2.3.2.3.3l4.9,8.7,5.3-3.1a1.2,1.2,0,0,0,.1-.5V89.8A2.3,2.3,0,0,0,133,88L78.2,56.4H78Z"
          transform="translate(-0.6 -0.4)"
        />
        <path
          class="b"
          d="M96,94.9c.1.8,2,26.8,3.8,36.4l23.1,13.2h.1l5.1,9c.1.2.3.3.4.2l5.4-3.2c.3-.1.5-.4.5-1V90s0-.2-.2,0l-5.5,3.3Z"
          transform="translate(-0.6 -0.4)"
        />
        <path
          class="c"
          d="M128.5,154.5h-.3c-.3,0-.4-.3-.6-.4l-5-8.9L99.2,131.9v-.5c-1.5-7.4-3-25.1-3.5-32.6-.2-2-.3-3.4-.3-3.7l.6-.2-.6.2v-.5l.4-.4,32.9-1.7,5.8-3.4h.5c.1.2.3.3.3.6v59.6a2.3,2.3,0,0,1-.6,1.5l-5.6,3.3C128.8,154.5,128.7,154.5,128.5,154.5Zm-28.1-23.7,23,13.4.3.3,5,8.7,5.2-3.2a.4.4,0,0,0,.2-.4V90.9l-5,3H129L96.8,95.4c0,.5.2,1.4.3,3.1C97.4,106.1,98.9,123.4,100.4,130.8Z"
          transform="translate(-0.6 -0.4)"
        />
        <path
          class="c"
          d="M127.5,154.1,72.8,122.5a2.9,2.9,0,0,1-1.2-2.4V60.3c0-.9.6-1.3,1.2-.9L127.5,91a3.1,3.1,0,0,1,1.2,2.4v59.8C128.7,153.9,128.2,154.4,127.5,154.1Z"
          transform="translate(-0.6 -0.4)"
        />
        <path
          class="c"
          d="M127.9,154.8a.8.8,0,0,1-.7-.3L72.5,123.1a3.6,3.6,0,0,1-1.5-3V60.3a1.7,1.7,0,0,1,.7-1.5c.5-.3.9-.1,1.5,0l54.6,31.5a3.4,3.4,0,0,1,1.5,3V153c0,.8-.3,1.4-.8,1.5A.6.6,0,0,1,127.9,154.8ZM72.2,59.9a.4.4,0,0,0-.2.4v59.8a2.6,2.6,0,0,0,.9,1.8l54.7,31.6h.2a1.2,1.2,0,0,0,.1-.5V93.3a2.1,2.1,0,0,0-.9-1.8L72.5,59.9Z"
          transform="translate(-0.6 -0.4)"
        />
        <path class="c" d="M82,57.5,76.4,61l.6,1,5.6-3.5Z" transform="translate(-0.6 -0.4)" />
        <path class="c" d="M133.8,143.4l-4.8,2.9.5.9,4.9-2.9Z" transform="translate(-0.6 -0.4)" />
        <path
          class="b"
          d="M93.9,120.5,81.3,102.7c-.1-.3-.3-.6-.1-.8l1.4-4.5Zm9.4,5.6L114.6,116l1.5,6.3c0,.3,0,.5-.1.5Zm-7.2-4.4-12-24.6,7.1,4.1Zm2.4,3.5-5.5-23,11,6.5L100.6,119Zm2.5-.6,4.8-14.1.2-.6,7,4-10.9,9.8ZM83.5,94.8l3.6-10.4,3.5,14.4Zm23.1,13.3,3.5-10.4,3.5,14.4Zm3.5-13c-.7-.5-1.3-.3-1.4.4L104.8,107l-12.3-7L88.6,84a2.6,2.6,0,0,0-1.5-2.1c-.7-.5-1.3-.3-1.5.4L81.5,94.5l-2.1,6.1a3.8,3.8,0,0,0,.9,3.4L98,129.3c.2.3.3.5.6.5h.6l18-4.6c.7-.1,1.2-1.2.9-2.5l-2.3-8.6v-.3l-4-16.8A3.4,3.4,0,0,0,110.1,95.1Z"
          transform="translate(-0.6 -0.4)"
        />
      </g>
      <g class="company github">
        <path
          class="b"
          d="M76.8,70.6l.2,2.7.9.5,5.8,9.7h.1l5.9-3.4c.3-.2.4-.5.4-1.1V55.1s0-.2-.1,0l-5.7,3.6Z"
          transform="translate(-0.6 -0.4)"
        />
        <path
          class="c"
          d="M83.5,84.6l-.4-.6-5.7-9.6L66.1,67.8a3.6,3.6,0,0,1-1.5-3V52.5L59,43.4l.2-.6.3-.2,5.8-3.4a1.6,1.6,0,0,1,1.5,0L89.2,52.1a3.4,3.4,0,0,1,1.5,3V79a2.3,2.3,0,0,1-.6,1.5Zm-23-41.1,5.3,8.7V64.8a2.3,2.3,0,0,0,.9,1.8l11.6,6.7.2.2L84,82.8l5.4-3.2V55.2a2.6,2.6,0,0,0-.9-1.8L66.1,40.5h-.2Z"
          transform="translate(-0.6 -0.4)"
        />
        <path
          class="b"
          d="M88.8,52.8,66.4,39.9a1.1,1.1,0,0,0-.8,0h-.1l-5.7,3.5,5.4,9.1V64.8a3.5,3.5,0,0,0,1.2,2.4l11.5,6.7,5.8,9.8,5.8-3.5c.3-.1.5-.4.5-1v-24A3.1,3.1,0,0,0,88.8,52.8Z"
          transform="translate(-0.6 -0.4)"
        />
        <path
          class="c"
          d="M84,84.3l-.6-.2-5.8-9.7-1.2-.6-.2-3.2h.2l7.4-12.1.2-.2,6-3.6.4.2a.6.6,0,0,1,.3.6V79.3a2.3,2.3,0,0,1-.6,1.5ZM77.7,73l.8.5h.1l5.5,9.3,5.4-3.1V56.3l-4.8,2.8L77.6,70.8Z"
          transform="translate(-0.6 -0.4)"
        />
        <path
          class="c"
          d="M82.9,83.7,60.5,70.8a3.1,3.1,0,0,1-1.2-2.4v-24c0-.9.6-1.3,1.2-.9L82.9,56.4a2.9,2.9,0,0,1,1.2,2.4v24C84.3,83.5,83.7,84,82.9,83.7Z"
          transform="translate(-0.6 -0.4)"
        />
        <path
          class="c"
          d="M83.5,84.4a.8.8,0,0,1-.7-.3L60.4,71.2a3.4,3.4,0,0,1-1.5-3V44.3c0-.8.3-1.4.7-1.5a1.6,1.6,0,0,1,1.5,0L83.5,55.7a3.4,3.4,0,0,1,1.5,3V82.6c0,.8-.3,1.4-.7,1.5Zm-.3-1.3h.2a1.2,1.2,0,0,0,.1-.5V58.7a2.1,2.1,0,0,0-.9-1.8L60.2,44h-.1a.4.4,0,0,0-.2.4v24a2.6,2.6,0,0,0,.9,1.8Z"
          transform="translate(-0.6 -0.4)"
        />
        <path class="c" d="M69.1,41.5,63.5,45l.7,1,5.5-3.5Z" transform="translate(-0.6 -0.4)" />
        <path class="c" d="M89.3,75.7l-4.8,2.9.5.9,4.9-2.9Z" transform="translate(-0.6 -0.4)" />
        <path
          class="b"
          d="M71.4,53.9c-4.6-2.7-8.5-.6-8.5,4.8a18.3,18.3,0,0,0,5.8,12.5.2.2,0,0,1,.2.2c.3.1.4,0,.4-.2V69.4l-.9-.4a4.2,4.2,0,0,1-1.9-2.4,5.6,5.6,0,0,0-.9-2c-.3-.3-.7-1,0-.6A9.8,9.8,0,0,1,67,65.8a4.2,4.2,0,0,0,1.4,2,1.7,1.7,0,0,0,.9.3c.2-.6.3-.9.6-1.1a8,8,0,0,1-3.8-7,2.2,2.2,0,0,1,.9-2.1,2.7,2.7,0,0,1,.1-2.5h.2a8.4,8.4,0,0,1,2,2.3,4.3,4.3,0,0,1,2.1.9,8,8,0,0,1,2.1,1.5,3.1,3.1,0,0,1,2.1.1l.2.2a5.6,5.6,0,0,1,.1,2.6,6.5,6.5,0,0,1,.9,3.2c0,3.7-1.9,3.4-3.9,2.5a4,4,0,0,1,.6,2.1v2.7a1.2,1.2,0,0,0,.5.8h.1c3.3.6,5.9-1.7,5.9-6S76.1,56.6,71.4,53.9Z"
          transform="translate(-0.6 -0.4)"
        />
      </g>
      <path
        class="b"
        d="M238.7,183.4l-4.8-3h-.7l-5,2.9c-.1,0-.1.1-.1.3l4.6,8.1h0v8.7a2.7,2.7,0,0,0,1.1,2.1l-4.4-2.4h.2l4.6,8.1c0,.2.1.2.3.2l4.9-2.9q.3-.1.3-.9V185.5A3,3,0,0,0,238.7,183.4Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M234.3,209.3h-.1c-.3,0-.4-.1-.6-.4l-4.6-8.1h.1l.6-1,2.4,1.2v-9l-4.6-8.1a.8.8,0,0,1,.3-1.2l4.9-2.8a1.4,1.4,0,0,1,1.5,0l4.8,3a3.5,3.5,0,0,1,1.5,2.7V205a1.5,1.5,0,0,1-.6,1.3l-5,3Zm-3.1-7.2,3.3,5.9,4.6-2.7V185.7a2.9,2.9,0,0,0-.7-1.7l-4.8-3h-.1l-4.7,2.7,4.5,7.8a.6.6,0,0,1,.2.5v8.6a2.9,2.9,0,0,0,.7,1.7l-.6,1Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M229.3,198.7s1.8-10.5,3.6-1.5l-3.5,3.3h.2l4.4,8h.5l4.8-2.8a1.9,1.9,0,0,0,.3-.9V185.8s0-.1-.2,0l-5.1,3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M234.5,209.3h-.3c-.3,0-.4-.3-.6-.4l-4.5-8H229l-.9,1.8.6-3.9q.9-5.7,2.7-5.7h.3l2.6-4.8,5.4-3.1h.5c.1.2.3.3.3.6V205a1.5,1.5,0,0,1-.6,1.3l-5,2.9Zm-4.2-8.8,4.2,7.5,4.6-2.7V186.9l-4,2.4-2.5,4.8a11.9,11.9,0,0,1,.9,3.1v.3Zm1.5-5.1-2.1,3.9,2.4-2.4A5.7,5.7,0,0,0,231.8,195.4Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M233.5,208.9l-4.8-3a2.7,2.7,0,0,1-1.1-2.1V184.5c0-.8.5-1.2,1.1-.9l4.8,3a2.8,2.8,0,0,1,1,2.1V208C234.6,208.9,234,209.2,233.5,208.9Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M233.9,209.6h-.7l-4.8-3a3.5,3.5,0,0,1-1.4-2.7V184.5a1.8,1.8,0,0,1,.8-1.5,1.2,1.2,0,0,1,1.3,0l4.8,3a3.4,3.4,0,0,1,1.3,2.7V208a2,2,0,0,1-.7,1.5Zm-.1-1.3h0c.1,0,.1,0,.1-.3V188.7a2.9,2.9,0,0,0-.7-1.7l-4.8-3h-.2v19.6a3,3,0,0,0,.8,1.7Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="c" d="M236.9,182l-5,3.1.7,1,4.9-3.1Z" transform="translate(-0.6 -0.4)" />
      <path class="a" d="M239.2,199.4l-4.4,2.6.5.9,4.4-2.6Z" transform="translate(-0.6 -0.4)" />
      <path
        class="b"
        d="M50.5,23l-4.8-3a.8.8,0,0,0-.7,0l-4.9,2.9c-.2,0-.2.1-.2.3l4.6,8v1.1a2.7,2.7,0,0,0,1.1,2.1L41.2,32h.2L46,40.2c0,.2.2.2.3.2l5-2.9a1.3,1.3,0,0,0,.3-.9V25.1A2.7,2.7,0,0,0,50.5,23Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M46.2,41.1h-.3a.5.5,0,0,1-.6-.4l-4.6-8.1h.1l.6-1,2.4,1.2V31.7l-4.6-8.1a.8.8,0,0,1,.3-1.2l4.9-2.8a1.4,1.4,0,0,1,1.5,0l4.8,3a3.5,3.5,0,0,1,1.5,2.7V36.8a1.5,1.5,0,0,1-.6,1.3l-5,3C46.5,41,46.3,41.1,46.2,41.1ZM43,33.8l3.3,5.8L51,36.9V25.1a2.7,2.7,0,0,0-.8-1.6l-4.8-3h-.1l-4.6,2.7,4.4,7.7a.6.6,0,0,1,.2.5v.9a2.6,2.6,0,0,0,.7,1.6L45.4,35Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M41.1,30.5S42.9,20,44.7,29l-3.5,3.3h.2l4.5,8h.4l4.8-2.8a1.2,1.2,0,0,0,.3-.9V25.4h-.1l-5.1,3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M46.2,41h-.3c-.3,0-.5-.3-.6-.5l-4.6-7.9-.5-.5,1.2-1.2-1.3.6V30.3c.6-3.7,1.5-5.6,2.7-5.6s1.5,1,1.9,3.4l1.1-.4,5.4-3.2.4.2a.6.6,0,0,1,.3.6V36.6a1.4,1.4,0,0,1-.6,1.4l-4.6,2.8C46.6,41,46.5,41,46.2,41Zm-4.1-8.9,4.2,7.5L51,36.9V26.3l-4.4,2.6-1.8.7ZM43.2,26A14.7,14.7,0,0,0,42,29.5l1.9-.9A10.2,10.2,0,0,0,43.2,26Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M45.3,40.5l-4.8-3a2.5,2.5,0,0,1-1-2.1V23.9c0-.7.4-1.2,1-.9l4.8,3a2.7,2.7,0,0,1,1,2.1V39.6C46.5,40.5,45.9,40.8,45.3,40.5Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M45.7,41.3a1,1,0,0,1-.7-.2l-4.8-3a3.4,3.4,0,0,1-1.3-2.7V23.9a2,2,0,0,1,.7-1.5,1.5,1.5,0,0,1,1.3,0l4.8,3a3.5,3.5,0,0,1,1.4,2.7V39.6a1.8,1.8,0,0,1-.8,1.5C46.2,41.3,46,41.3,45.7,41.3Zm-.1-1.4h0c.1,0,.1,0,.1-.3V28.1a2.6,2.6,0,0,0-.7-1.6l-4.8-3h-.1V35.3a2.6,2.6,0,0,0,.7,1.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="c" d="M48.7,21.4l-5,3.1.7,1,4.9-3.1Z" transform="translate(-0.6 -0.4)" />
      <path class="a" d="M51,31.1l-4.4,2.6.5.9L51.5,32Z" transform="translate(-0.6 -0.4)" />
      <path
        class="c"
        d="M165,256.7h-1.8l-13.7,7.9c-.2.3-.3.8-.5,1.1Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="c" d="M167.5,256.5l-18.8,10.8v.9l20.2-11.7Z" transform="translate(-0.6 -0.4)" />
      <path
        class="c"
        d="M172.3,256.8h-1.2L149,269.4c0,.3.2.4.3.7Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M175.2,257.3a2.2,2.2,0,0,0-1.1-.2l-24.3,14.1.4.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="c" d="M176.8,257.7l-25.8,15,.5.6,26.4-15.1Z" transform="translate(-0.6 -0.4)" />
      <path
        class="c"
        d="M179.9,258.9l-.9-.3L152.3,274c.1.2.4.3.6.5Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M181.6,259.8l-.5-.2-27.2,15.8c.2.1.3.1.3.3h.3l27.2-15.7C181.9,259.9,181.7,259.8,181.6,259.8Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M183.7,261.1l-.6-.4L156,276.3a3.2,3.2,0,0,0,.9.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="c" d="M185,262.5l-.6-.6L158.1,277l.9.3Z" transform="translate(-0.6 -0.4)" />
      <path
        class="c"
        d="M186.2,264l-.4-.6-25.1,14.5a1.8,1.8,0,0,0,1,.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M187,265.8c0-.3-.2-.5-.3-.8l-23,13.4h1.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M187.1,267l-20.3,11.7h1.5l18.8-11C187.3,267.6,187.3,267.3,187.1,267Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M186.5,270.4c.2-.3.3-.7.5-1l-16,9.3,1.8-.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M182,275.2a19.1,19.1,0,0,0,3.3-2.7l-8.8,5.1a16.6,16.6,0,0,0,4.8-1.9Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M154.4,259.8a15.5,15.5,0,0,0-3.6,2.8l8.7-4.9A21,21,0,0,0,154.4,259.8Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M155.6,150.3s-4.5,14.1-4.5,24.9a11,11,0,0,0,.4,3.1c1.2,4.7,3.8,19.8,3.8,19.8L166.5,186,161,164.7Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M184.9,199.4c-2.4-2.2-8.4,1.7-12.6,4.8-1-7.5-16.4-1.3-16.4-1.3s1.6,20.1,1,25.3-3.3,8.7-3.1,20.4c.1,9.3,0,12.8,0,13.9a.7.7,0,0,0,.3.6,5.3,5.3,0,0,0,6,0c.1-.2.3-.3.3-.5.3-2.5,2.8-19,4.5-22.7a34.4,34.4,0,0,0,1.6-8.6,16.1,16.1,0,0,1,.7-4.3c.5-1.2.8-4.6,1.2-4.8a6.8,6.8,0,0,1,.6,2.9c.2,3.1.5,5.9.6,7.1.6,4.4-1,8.6-1.6,14s1.2,18.7,1.6,22a1.5,1.5,0,0,0,.8,1.2,5.7,5.7,0,0,0,5.8.1,1.6,1.6,0,0,0,.9-1.5c0-3.4.2-16.6,1.4-20.8a61.7,61.7,0,0,0,1.6-10.8s3.9-16.7,4.6-29.3C185,204.8,185.8,200.2,184.9,199.4Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M155,199.6l-.2-1.4c0-.1-2.5-15.1-3.7-19.7a13.9,13.9,0,0,1-.4-3.5c0-10.8,4.4-24.8,4.4-25l.6-1.8,6,16.2,5.5,21.6Zm.7-47.2c-1.2,4.2-3.9,14.5-3.9,22.8a11.7,11.7,0,0,0,.5,3c1,3.9,2.8,14.8,3.6,18.5l10-10.9L160.5,165Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M170.5,267a14.5,14.5,0,0,0-1,6.1,2.1,2.1,0,0,0,1.3,1.8l2.7.8a2.2,2.2,0,0,0,2.3-.6l1-1.1a5,5,0,0,1,2.1-1.2,2.9,2.9,0,0,0,1.6-.7l5.1-3.8a1.6,1.6,0,0,0,.5-2.2,4.4,4.4,0,0,0-2.3-1.5c-2.8-.8-7.7.4-7.7.4Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M174.1,276.3a1.5,1.5,0,0,1-.9-.2l-2.7-.7a2.5,2.5,0,0,1-1.8-2.4,16.5,16.5,0,0,1,1.1-6.3v-.3l5.7-2c.3,0,5.2-1.2,8.2-.4a5.1,5.1,0,0,1,2.7,1.6,3.4,3.4,0,0,1,.5,1.7,3.2,3.2,0,0,1-.9,1.5l-5.1,3.7a2.9,2.9,0,0,1-1.8.8,3.1,3.1,0,0,0-1.8.9l-1,1A2.7,2.7,0,0,1,174.1,276.3Zm-3.1-8.7a12.7,12.7,0,0,0-.9,5.5,1.2,1.2,0,0,0,.9,1.2l2.7.8a1.6,1.6,0,0,0,1.6-.5l1.1-1a4,4,0,0,1,2.4-1.4l1.3-.6,5.1-3.7.4-.6c0-.3,0-.5-.1-.6a3,3,0,0,0-2-1.2c-2.5-.6-7.4.4-7.4.4Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M155.3,257.9s-1.2,5.5-1.8,7.1a3.3,3.3,0,0,0,.1,2.4,1.4,1.4,0,0,0,1.1.9l3.1.8a2.1,2.1,0,0,0,2.1-.9,21.7,21.7,0,0,1,3.2-3.6l3.1-2.7a2.8,2.8,0,0,0,.7-3.1c-.3-.9-2-1.4-3.8-1.5l-3.3-.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M158.3,270h-.6l-3.2-.8A2.2,2.2,0,0,1,153,268a3.9,3.9,0,0,1-.1-2.8l1.8-7.2v-.4l5-.8a30.9,30.9,0,0,1,3.4.2c2.5.3,4,.9,4.3,1.9a3.7,3.7,0,0,1-.9,3.9l-3.2,2.7a12.8,12.8,0,0,0-3,3.4A2.5,2.5,0,0,1,158.3,270Zm-2.6-11.5c-.3,1.3-1.2,5.3-1.6,6.8a3.1,3.1,0,0,0,.1,2.1c.2.3.3.5.6.6l3.2.8a1.3,1.3,0,0,0,1.3-.6,22.4,22.4,0,0,1,3.3-3.8l3.1-2.7a2.4,2.4,0,0,0,.6-2.5c-.1-.4-1-.9-3.2-1.2h-3.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M162.5,146.7a4.5,4.5,0,0,0-6.2,1.8c-2.4,4.1-1.5,14.4-.6,23.7s-2.1,25-2.7,28.3a1.2,1.2,0,0,0,.5.9l4.6,2.4a41.7,41.7,0,0,0,17.4,3.9,14.7,14.7,0,0,0,6.1-1.4h.4a10,10,0,0,0,5.1-5.4s-5.8-12.7-5.8-21.3,2.8-24.1-2.5-27.1a13.2,13.2,0,0,0-10.5-1Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M175.5,208.3a39.5,39.5,0,0,1-17.5-4.1l-4.7-2.4a1.2,1.2,0,0,1-.7-1.5c.6-3.3,3.6-19.9,2.7-28.1-1.1-10.1-1.8-19.9.6-24a5.8,5.8,0,0,1,3.1-2.7,6.2,6.2,0,0,1,3.8.6l5.5,4.5a13.7,13.7,0,0,1,10.6,1.2c4.5,2.4,3.7,12,3.3,20.5-.2,2.6-.3,5.1-.3,7.2,0,8.3,5.7,20.8,5.8,21l.2.3-.2.3a11.1,11.1,0,0,1-5.4,5.7h-.4A16.1,16.1,0,0,1,175.5,208.3Zm-15.4-61.7h-.8a4.6,4.6,0,0,0-2.4,2.1c-2.2,3.9-1.5,13.9-.4,23.2s-2.1,25.3-2.9,28.6c0,.2,0,.2.2.2l4.6,2.4a40.4,40.4,0,0,0,17.1,3.9,13.4,13.4,0,0,0,5.8-1.4h.4a10.6,10.6,0,0,0,4.8-4.8c-.9-2-5.8-13.2-5.8-21.3,0-2.1.1-4.6.3-7.2.4-7.6,1.2-17.2-2.5-19.3a12,12,0,0,0-9.9-.9l-.3.2-6-5A3.5,3.5,0,0,0,160.1,146.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M164.1,147.3a.4.4,0,0,0,.3.6c1.2,1.1,4.5,3.6,10.5,1.8v-4.3a.2.2,0,0,1,.2-.2l3.1-1s2.7-3.6,1.9-11.1l-.7-3.2-6.7-.4-5.3,5.5-.9,5.7A29.7,29.7,0,0,1,164.1,147.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M171,150.9a9.6,9.6,0,0,1-6.9-2.5v-.2a.9.9,0,0,1-.3-1.3,23.8,23.8,0,0,0,2.2-6.5l.9-5.8,5.7-5.8,7.4.4.9,3.7c.8,7.8-1.9,11.4-2,11.6h-.2l-3,1.1v4.5H175A12.1,12.1,0,0,1,171,150.9Zm-6.1-3.6h0c1.1,1.1,4.1,3.3,9.5,1.8l.2-3.9a.7.7,0,0,1,.4-.7l3-1.1c.5-.7,2.2-4.2,1.8-10.5l-.8-2.7-5.9-.4-5.1,5.4-.9,5.5A24.4,24.4,0,0,1,164.9,147.3Zm-.8,0,.6.3-.6-.3.6.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M165.1,147.5a2.1,2.1,0,0,0-2.6-.6,1.9,1.9,0,0,0-1.2.6c-1.8,1.9,4.4,7.8,12.2,5.5a16.7,16.7,0,0,1,3.8-.6h1.2a6.5,6.5,0,0,0-2.4-2.7,1.8,1.8,0,0,0-2,0c-.7.4-2.2.6-4.5.1A7.7,7.7,0,0,1,165.1,147.5Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M170.1,154.2c-4.5,0-7.9-2.2-9.1-4.2a2.2,2.2,0,0,1-.2-2.8,4.8,4.8,0,0,1,1.1-.8h.3a2.8,2.8,0,0,1,3.4.7,7.3,7.3,0,0,0,4.3,2.1c2.7.5,3.8.2,4.1,0a2.2,2.2,0,0,1,2.7,0,7.4,7.4,0,0,1,2.5,3v.3l-.3.6-1.6.2a19.3,19.3,0,0,0-3.6.6A16.1,16.1,0,0,1,170.1,154.2Zm-6.7-6.9c-.2,0-.5,0-.6.2h-.5l-.6.3a1.4,1.4,0,0,0,.2,1.4c1.5,2.2,6.1,4.6,11.5,3.1a15.9,15.9,0,0,1,3.9-.6h.3a7.6,7.6,0,0,0-1.8-1.6,1.1,1.1,0,0,0-1.2,0c-.9.6-2.6.6-5,.3a9,9,0,0,1-5-2.4A1.2,1.2,0,0,0,163.4,147.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M164.1,205.3c-3.3-4.7-2.2-13.6-2.2-13.9h1.2c0,.2-1.1,8.8,1.9,13Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="b"
        d="M199.1,145.1c-.9-1.5-1.2-2.4-2.3-1.8l-.4.6a9.1,9.1,0,0,0-1.1,2.2,5.3,5.3,0,0,0-.1,1.2v2h-.3s-.3-1.7-1.4-2-1.1,1.2-1.1,1.2v1.2a15.3,15.3,0,0,0,1.1,4.8l5,1.5a23,23,0,0,1,1.5-3.6C200.6,150.8,200,146.9,199.1,145.1Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M198.8,156.6l-5.7-1.8-.2-.3a17.4,17.4,0,0,1-1.3-5.1v-1.2a2.1,2.1,0,0,1,.9-1.6,1,1,0,0,1,1.2,0,1.1,1.1,0,0,1,.7.6,2.3,2.3,0,0,1,.2-1.2,8.2,8.2,0,0,1,1-2.6l.5-.7h.1a2.4,2.4,0,0,1,1.4-.3c.7.1,1.2.9,1.6,1.9l.2.3c1,1.8,1.8,6,.9,7.8a23.7,23.7,0,0,0-1.5,3.5Zm-4.8-2.8,4,1.2a26.1,26.1,0,0,1,1.4-3.2c.6-1,.1-4.8-.9-6.6l-.2-.3c-.3-.6-.7-1.3-.9-1.3h-.3l-.3.4a8.8,8.8,0,0,0-.9,2c0,.3-.1.7-.1,1v1.4h0v1.1l-1.4-.3v-.5c-.2-.4-.5-1.3-.9-1.5s-.3.3-.3.8v1A11.6,11.6,0,0,0,194,153.8Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M176.4,159.5a52.9,52.9,0,0,0,8.9,20.8,27.3,27.3,0,0,0,4.8,4.8,1.7,1.7,0,0,0,2.4-.5l.6-.6a9.9,9.9,0,0,0,2.4-3.6,8.8,8.8,0,0,0,.6-2.8l2.4-19.6a2,2,0,0,0-1.2-1.8l-3.2-1.1a.7.7,0,0,0-.9.6c-.3,2.3-1,5.9-1.9,9.9s-.9,11.5-.9,11.5-4.2-19.6-8.5-23S175.5,155.6,176.4,159.5Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M191.2,186a2.7,2.7,0,0,1-1.4-.5,22.7,22.7,0,0,1-4.9-4.9,53.6,53.6,0,0,1-9.1-21.1c-.6-2.4-.2-5.6,1.8-6.9s2.5-.9,4.6.9,6.1,12.5,7.6,18.7a47,47,0,0,1,.8-6.8c1-4.3,1.6-7.7,1.9-9.8a1.5,1.5,0,0,1,.6-1.1,1.6,1.6,0,0,1,1.2-.1l3.1,1a2.5,2.5,0,0,1,1.7,2.4l-2.6,19.6a10.1,10.1,0,0,1-.7,3,10.7,10.7,0,0,1-2.6,3.9l-.4.5a2.1,2.1,0,0,1-1.5.9C191.3,186,191.3,186,191.2,186ZM179,153.6a1,1,0,0,0-.8.3c-1.2.8-1.8,3.3-1.2,5.6a50.9,50.9,0,0,0,8.8,20.5,19.2,19.2,0,0,0,4.8,4.6.6.6,0,0,0,.7.2.6.6,0,0,0,.6-.5h.2l.5-.6a7.7,7.7,0,0,0,2.3-3.5,8.8,8.8,0,0,0,.6-2.7l2.5-19.6a1.1,1.1,0,0,0-.7-1l-3.2-1.1v.2c-.3,2.1-.9,5.5-1.9,10s-.9,11.2-.9,11.4v6.1l-1.4-6c0-.1-4.2-19.4-8.4-22.7A3.6,3.6,0,0,0,179,153.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M165.1,126.5a12.3,12.3,0,0,0-3.2,5.1,9.9,9.9,0,0,0,1,8.2c3.3,5.1,7.9,3.8,9,3.3s.1-.1.1-.3-.4-4.2,1.2-6.3a5,5,0,0,1,4.2-1.8h.3c.6-.6,3.9-3.9,1.6-7.6s-8.3-6.2-13-4.2c-.1,0-.1.3,0,.3s1.4.7.5,1.9A12.2,12.2,0,0,1,165.1,126.5Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M169.2,144.2c-2,0-4.6-.8-6.7-4.1a10.1,10.1,0,0,1-1.2-8.7,13.3,13.3,0,0,1,3.4-5.3,10.7,10.7,0,0,0,1.5-1.7c.1-.3.3-.4.3-.6s-.2-.3-.5-.3a.7.7,0,0,1-.4-.7.9.9,0,0,1,.4-.8c5-1.9,11.3.2,13.9,4.5s-1,7.8-1.7,8.4a1.9,1.9,0,0,1-.8.3,3.8,3.8,0,0,0-3.7,1.6c-1.7,2.1-1.2,5.7-1.2,5.9a1,1,0,0,1-.6,1A11.5,11.5,0,0,1,169.2,144.2Zm-1.8-21.4a1.1,1.1,0,0,1,.3.6,1.7,1.7,0,0,1-.5,1.6,12.9,12.9,0,0,1-1.6,1.8,9.3,9.3,0,0,0-3.1,4.8,8.4,8.4,0,0,0,1,7.6c2.8,4.4,6.6,3.6,7.9,3.2s-.3-4.4,1.5-6.6a5.8,5.8,0,0,1,4.7-2.1c.7-.8,3.2-3.6,1.4-6.7A11,11,0,0,0,167.4,122.8Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M172.9,127.4c-.9-1.9-4.2-1.8-5.5-1.8l-.2-1.2c2-.1,5.6-.1,6.8,2.4Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M170.1,141c-3.8,0-4.2-3.1-4.2-3.1l1.2-.2c0,.3.6,2.6,4,2l.2,1.2Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M169.6,154.4a11.1,11.1,0,0,1-6.8-2.4c-.2-.2-.5-.3-.6-.5H162a3.3,3.3,0,0,1-.7-4.5l1,.7a2.2,2.2,0,0,0,.5,2.9h.1c.2.2.5.3.6.5a9.9,9.9,0,0,0,7.8,2.1,33.2,33.2,0,0,0,6.4-1.2l.5,1.2a30.2,30.2,0,0,1-6.8,1.3A3.7,3.7,0,0,0,169.6,154.4Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M180.8,174.3c-.1-.5-4.9-9.8-5.2-14.8a21.2,21.2,0,0,1,.2-3.9H177a18.4,18.4,0,0,0-.2,3.6c.2,4.8,4.9,14.2,5.1,14.4Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M189.8,175.9a14.6,14.6,0,0,0-.4-3.4l1.2-.3a16.9,16.9,0,0,1,.4,3.7Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M168.4,224c-1-4-2.2-10.8-2.2-10.8h1.2s1,6.7,2.1,10.8Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M163.7,188.8h-1.2a14.9,14.9,0,0,0,0-3.9l1.2-.2A12.9,12.9,0,0,1,163.7,188.8Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M155,202.7l-1.2-.7a2.1,2.1,0,0,1-.9-2.3c.1-1.3.6-3.4.7-5.8l1.2.2c-.3,2.3-.6,4.4-.7,5.8a1.3,1.3,0,0,0,.4,1l1.2.8Z"
        transform="translate(-0.6 -0.4)"
      />
      <path class="a" d="M193.5,158l-.3,1.2,4.3,1.2.3-1.1Z" transform="translate(-0.6 -0.4)" />
      <path
        class="a"
        d="M183.4,196.3a13.9,13.9,0,0,1-2.1-5.1h1.2a11.7,11.7,0,0,0,1.8,4.6Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M164.9,260.2c-.6-1.4-3.5-1.1-3.5-1.1v-1.2c.1,0,3.7-.5,4.7,1.9Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="a"
        d="M183.2,267.9c-.9-2.3-3.7-2.1-3.7-2.1l-.2-1.2a4.8,4.8,0,0,1,5.1,2.8Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M181.3,217.7a5.2,5.2,0,0,1-2.5-.7c-2.9-1.8-3-6.3-3-6.5H177s.1,4.1,2.3,5.6a4.4,4.4,0,0,0,4.2,0l.5,1.2A8.4,8.4,0,0,1,181.3,217.7Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M160.1,236.3a6.6,6.6,0,0,1-4.4-4.2l1.2-.3a5.2,5.2,0,0,0,3.5,3.3Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M174.6,242.1c-5.4-.4-5.6-4.3-5.6-4.3h1.2c0,.1.2,2.8,4.5,3.1Z"
        transform="translate(-0.6 -0.4)"
      />
      <path
        class="c"
        d="M173.7,271.2a7.7,7.7,0,0,1-3.5-.9,1.8,1.8,0,0,1-1-1.7c-.5-4-2.1-17.3-1.7-22.1.2-2.1.6-4.1.9-5.9a24.4,24.4,0,0,0,.8-7.9c-.2-1.2-.3-3.6-.6-7.3a19.3,19.3,0,0,1-.5,2,19.4,19.4,0,0,0-.7,4.2,31.5,31.5,0,0,1-1.7,8.9c-1.4,3.6-4,19.6-4.4,22.6a1.1,1.1,0,0,1-.6.9,5.9,5.9,0,0,1-6.8,0,1.6,1.6,0,0,1-.6-1.2c0-1.1.2-4.6,0-13.9a50,50,0,0,1,2-15.5,30.6,30.6,0,0,0,1-5.1c.6-5.2-1-25-1-25.3v-.4l.4-.2c.5-.1,10.5-4.2,15.1-1.5a4.7,4.7,0,0,1,2,2.4c6.2-4.6,10.4-6.1,12.5-4.2s.8,3,.3,6.3c0,.8-.1,1.4-.1,2-.8,12.1-4.4,28.4-4.7,29.5a54.7,54.7,0,0,1-1.6,10.9c-1.2,4.2-1.3,18-1.3,20.7a2.2,2.2,0,0,1-1.2,1.9A7.5,7.5,0,0,1,173.7,271.2Zm-4.8-49.7.3.6a7.1,7.1,0,0,1,.6,2.8v.3c.3,3.6.4,6,.6,7.2a26.9,26.9,0,0,1-.8,8.4c-.3,1.8-.7,3.6-.9,5.7-.4,4.8,1.2,19.1,1.7,21.8a.9.9,0,0,0,.4.8,5.4,5.4,0,0,0,5.3.1,1.1,1.1,0,0,0,.6-.9c0-3.9.1-16.7,1.3-21.1a59.4,59.4,0,0,0,1.6-10.6v-.2c0-.1,3.9-16.9,4.7-29.3,0-.6.1-1.2.1-2s.5-4.8,0-5.2-5.8.3-11.6,4.8l-.9.6-.2-1.1a3.1,3.1,0,0,0-1.6-2.4c-3.6-2.1-11.5.8-13.5,1.5.3,3.2,1.5,20.1,1.1,25a25.3,25.3,0,0,1-1.2,5.3,48.5,48.5,0,0,0-2,15.1c.2,9.3,0,12.9,0,13.9v.2a4.7,4.7,0,0,0,5.4,0v-.2c.3-1.8,2.9-18.8,4.7-22.9a33.1,33.1,0,0,0,1.6-8.4,16.2,16.2,0,0,1,.7-4.4,21.4,21.4,0,0,0,.5-2.3c.4-2.2.6-2.7.9-3Z"
        transform="translate(-0.6 -0.4)"
      />
    </g>
  </svg>
</template>

<script>
import coords from "@/components/coords.js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { mapState } from "vuex";

gsap.registerPlugin(ScrollTrigger);

export default {
  computed: {
    ...mapState([
      "toggleConfig",
      "startConfig",
      "isAnimationDisabled",
      "viewportSize",
    ]),
  },
  mixins: [coords],
  props: {
    x: {
      type: [Number, String],
      default: 350,
    },
    y: {
      type: [Number, String],
      default: 350,
    },
    xSmall: {
      type: [Number, String],
      default: 50,
    },
    ySmall: {
      type: [Number, String],
      default: 1550,
    },
  },
  methods: {
    githubAnim() {
      gsap.set(".company, .access", {
        transformOrigin: "50% 50%",
      });

      gsap
        .timeline({
          scrollTrigger: {
            trigger: "#milestone-github",
            toggleActions: this.toggleConfig,
            start: this.startConfig,
          },
          defaults: {
            duration: 1.5,
          },
        })
        .add("github")
        .fromTo(
          ".thought-bubbles g",
          {
            opacity: 0,
            scale: 0,
            rotation: -30,
            transformOrigin: "50% 50%",
          },
          {
            opacity: 1,
            scale: 1,
            stagger: -0.3,
            rotation: 0,
            ease: "back.out(1.7)",
          },
          "github"
        )
        .fromTo(
          ".access",
          {
            opacity: 0,
            scale: 0,
            rotation: 180,
            transformOrigin: "50% 50%",
          },
          {
            opacity: 1,
            scale: 1,
            rotation: 0,
            stagger: 0.1,
            ease: "sine",
          },
          "github"
        )
        .fromTo(
          ".company",
          {
            duration: 1,
            opacity: 0,
            scale: 0,
            transformOrigin: "50% 50%",
          },
          {
            opacity: 1,
            scale: 1,
            stagger: 0.3,
            ease: "back.out(1.7)",
          },
          "github+=0.5"
        );
    },
  },
  mounted() {
    this.githubAnim();
  },
};
</script>

<style lang="scss" scoped>
.company,
.access,
.thought-bubbles g {
  opacity: 0;
}

.a {
  fill: #ffad43;
}

.d {
  fill: #caa677;
}

.b {
  fill: #fff;
}

.c {
  fill: #0e1e25;
}
</style>
